export default class {
  constructor({ speed = 33 }) {
    this.canvas = null;
    this.resize_timeout = null;
    this.ctx = null;
    this.mp = 50;
    this.particles = [];
    this.angle = 0;

    // update interval time, 33-50 for smooth, 160 for 8 bit style
    this.speed = speed;
    // this.speed = 1000;
    this.audio = null;
    this.clouds = null;
    this.elfs = null;
    this.snowball = null;
    this.image_position_state = false;

    // allo clouds to animate slower
    this.current_image_tick = 0;
    this.max_image_ticks = 6;
  }

  start() {
    if (!this.canvas) {
      this.create();
      window.addEventListener('resize', this.resizeHandler.bind(this), false);
    }

    this.update_interval = setInterval(() => {
      this.draw();
    }, this.speed);
  }

  resizeHandler() {
    window.clearTimeout(this.resize_timeout);
    if (this.canvas) {
      this.resize_timeout = setTimeout(() => {
        this.resize();
      }, 300);
    }
  }

  addImages(el) {
    this.image_position_state = false;
    this.current_image_tick = 0;

    /* eslint-disable max-len */
    el.innerHTML = `<div class="relative" style="width: 700px; height: 80vh; max-height: 740px;">

      <div id="clouds" class="flex" style="padding-top: 32px;">
        <div data-type="cloud" style="padding: 24px 32px 0;">${this.cloud3()}</div>
        <div data-type="cloud" style="padding: 64px 32px 0;">${this.cloud2()}</div>
        <div data-type="cloud" style="padding: 0 32px;">${this.cloud1()}</div>
      </div>

      <div class="flex flex-align-end" style="position: absolute; left: 50%; bottom: 124px; transform: translateX(-50%); width: 100%; z-index: 1;">
        <div data-type="elf" style="padding: 0 30px 0 50px;">${this.boy2()}</div>
        <div data-type="elf" style="padding: 0 32px 0 20px;">${this.boy1()}</div>
        <div class="flex-grow"></div>
        <div data-type="elf" style="padding: 0 32px 0 48px;">${this.girl1()}</div>
        <div data-type="elf" style="padding: 0 42px 0 0;">${this.girl2()}</div>
        <div data-type="snowball" style="position: absolute; top: 64px; left: 410px;">${this.sb()}</div>
      </div>
      <div style="position: absolute; left: 50%; bottom: 0; transform: translateX(-50%); z-index: 0;">${this.snow()}</div>

    </div>`;
    this.clouds = el.querySelectorAll('[data-type="cloud"]');
    this.elfs = el.querySelectorAll('[data-type="elf"]');
    this.snowball = el.querySelector('[data-type="snowball"]');
  }

  checkaudio() {
    if (this.audio && this.audio.paused) {
      this.audio.play();
    }
  }

  music(on = true) {
    if (on && !this.audio) {
      this.audio = document.createElement('audio');
      this.audio.style.display = 'none';
      this.audio.autoplay = true;

      this.audio.loop = true;
      this.audio.volume = 0.15;
      this.audio.style.opacity = '0';
      this.audio.style.position = 'fixed';
      this.audio.style.zIndex = '-1';
      this.audio.type = 'audio/mp3';
      this.audio.src =
        window.__nexd.cdn +
        'dist/assets/music/an0va_-_The_First_Noel_O_Come_All_Ye_Faithful.mp3';
      document.body.appendChild(this.audio);

      this.volume_slider = document.createElement('div');
      this.volume_slider.style.position = 'fixed';
      this.volume_slider.style.zIndex = '999999';
      this.volume_slider.style.width = '230px';
      this.volume_slider.style.top = '1rem';
      this.volume_slider.style.left = '1rem';
      this.volume_slider.classList.add('flex');

      const slider_wrapper = document.createElement('div');
      slider_wrapper.style.width = '80px';

      let label = document.createElement('small');
      label.style.color = 'white';
      label.innerHTML = 'Volume:';

      let slider = document.createElement('input');
      slider.style.width = '100%';
      slider.type = 'range';
      slider.min = 0;
      slider.max = 1;
      slider.step = 0.01;
      slider.value = this.audio.volume;
      slider.oninput = () => {
        this.audio.volume = slider.value;
      };

      let play_pause = document.createElement('div');
      play_pause.style.width = '150px';
      play_pause.classList.add('cursor-pointer');
      play_pause.classList.add('text-left');

      const setIconState = () => {
        if (this.audio.paused) {
          play_pause.innerHTML = this.play();
        } else {
          play_pause.innerHTML = this.pause();
        }
      };

      this.audio.oncanplay = () => {
        setIconState();
      };

      const setAudioState = () => {
        if (this.audio.paused) {
          this.audio.play();
        } else {
          this.audio.pause();
        }
        setIconState();
      };

      play_pause.onclick = () => {
        setAudioState();
      };

      slider_wrapper.appendChild(label);
      slider_wrapper.appendChild(slider);
      // this.volume_slider.appendChild(slider_wrapper);

      this.volume_slider.appendChild(play_pause);
      document.body.appendChild(this.volume_slider);
    } else if (!on) {
      if (this.audio && this.audio.parentNode) {
        this.audio.parentNode.removeChild(this.audio);
      }
      if (this.volume_slider && this.volume_slider.parentNode) {
        this.volume_slider.parentNode.removeChild(this.volume_slider);
      }
    }
  }

  stop() {
    window.clearInterval(this.update_interval);
    window.clearTimeout(this.resize_timeout);
    this.canvas.parentNode.removeChild(this.canvas);
    this.music(false);
    window.removeEventListener('resize', this.resizeHandler.bind(this), false);
  }

  create() {
    this.canvas = document.createElement('canvas');
    this.canvas.style.position = 'fixed';
    this.canvas.style.top = 0;
    this.canvas.style.left = 0;
    this.canvas.style.zIndex = 999999;
    this.canvas.style.pointerEvents = 'none';
    this.ctx = this.canvas.getContext('2d');
    document.body.prepend(this.canvas);
    this.resize();

    //snowflake particles
    for (let i = 0; i < this.mp; i++) {
      this.particles.push({
        x: Math.random() * this.W,
        y: Math.random() * this.H,
        r: Math.random() * 4 + 1, //radius
        d: Math.random() * this.mp, //density
      });
    }
  }

  //Lets draw the flakes
  draw() {
    this.ctx.clearRect(0, 0, this.W, this.H);
    this.ctx.fillStyle = 'rgba(255, 255, 255, 1)';
    this.ctx.beginPath();
    for (let i = 0; i < this.mp; i++) {
      const p = this.particles[i];
      this.ctx.moveTo(p.x, p.y);
      this.ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2, true);
      this.ctx.shadowBlur = 1;
      this.ctx.shadowColor = 'black';
    }
    this.ctx.fill();
    this.update();

    this.updateImages();
  }

  update() {
    this.angle += 0.01;
    for (let i = 0; i < this.mp; i++) {
      const p = this.particles[i];
      //Updating X and Y coordinates
      //We will add 1 to the cos function to prevent negative values which will lead flakes to move upwards
      //Every particle has its own density which can be used to make the downward movement different for each flake
      //Lets make it more random by adding in the radius
      p.y += Math.cos(this.angle + p.d) + 1 + p.r / 2;
      p.x += Math.sin(this.angle) * 2;

      //Sending flakes back from the top when it exits
      //Lets make it a bit more organic and let flakes enter from the left and right also.
      if (p.x > this.W + 5 || p.x < -5 || p.y > this.H) {
        //66.67% of the flakes
        if (i % 3 > 0) {
          this.particles[i] = {
            x: Math.random() * this.W,
            y: -10,
            r: p.r,
            d: p.d,
          };
        } else {
          //If the flake is exitting from the right
          if (Math.sin(this.angle) > 0) {
            //Enter from the left
            this.particles[i] = {
              x: -5,
              y: Math.random() * this.H,
              r: p.r,
              d: p.d,
            };
          } else {
            //Enter from the right
            this.particles[i] = {
              x: this.W + 5,
              y: Math.random() * this.H,
              r: p.r,
              d: p.d,
            };
          }
        }
      }
    }
  }

  updateImages() {
    this.current_image_tick++;

    if (this.current_image_tick >= this.max_image_ticks) {
      if (this.clouds) {
        this.clouds.forEach((cloud, index) => {
          let step = 10;
          if (
            (this.image_position_state && index % 2 === 0) ||
            (!this.image_position_state && index % 2 === 1)
          ) {
            step *= -1;
          }
          cloud.style.transform = `translateX(${step}px)`;
        });
      }
      if (this.elfs) {
        this.elfs.forEach((elf, index) => {
          let step = 5;
          if (
            (this.image_position_state && index % 2 === 0) ||
            (!this.image_position_state && index % 2 === 1)
          ) {
            step *= -1;
          }
          elf.style.margin = `${step}px 0`;
        });
      }

      if (this.snowball) {
        const current = this.snowball.style.left;
        if (!current || current === '') {
          this.snowball.style.left = '270px';
        } else if (current === '270px') {
          this.snowball.style.left = '340px';
        } else if (current === '340px') {
          this.snowball.style.left = '410px';
        } else if (current === '410px') {
          this.snowball.style.left = '341px';
        } else {
          this.snowball.style.left = '270px';
        }
      }

      this.current_image_tick = 0;
      this.image_position_state = !this.image_position_state;
    }
  }

  resize() {
    this.W = window.innerWidth;
    this.H = window.innerHeight;
    this.canvas.width = this.W;
    this.canvas.height = this.H;
  }

  play() {
    return `<svg width="150" height="48" viewBox="0 0 150 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M57 12.75V12H59.25H61.5V12.75V13.5H62.25H63V14.25V15H63.75H64.5V18.75V22.5H63H61.5V21V19.5H59.25H57V21V22.5H55.5H54V18.75V15H54.75H55.5V14.25V13.5H56.25H57V12.75ZM60 14.25V13.5H59.25H58.5V14.25V15H57.75H57V16.5V18H59.25H61.5V16.5V15H60.75H60V14.25ZM67.5 15.75V15H72H76.5V15.75V16.5H72.75H69V18.75V21H72.75H76.5V21.75V22.5H72H67.5V21.75V21H66.75H66V18.75V16.5H66.75H67.5V15.75ZM82.5 13.5V12H84H85.5V13.5V15H87H88.5V15.75V16.5H87H85.5V19.5V22.5H84H82.5V19.5V16.5H81H79.5V15.75V15H81H82.5V13.5ZM93 15.75V15H95.25H97.5V18V21H99H100.5V21.75V22.5H96H91.5V21.75V21H93H94.5V18.75V16.5H93.75H93V15.75ZM94.5 12.75V12H96H97.5V12.75V13.5H96H94.5V12.75ZM103.5 17.25V15H105H106.5V17.25V19.5H108H109.5V17.25V15H111H112.5V17.25V19.5H111.75H111V20.25V21H110.25H109.5V21.75V22.5H108H106.5V21.75V21H105.75H105V20.25V19.5H104.25H103.5V17.25ZM115.5 15.75V15H119.25H123V15.75V16.5H123.75H124.5V19.5V22.5H120H115.5V21.75V21H114.75H114V20.25V19.5H114.75H115.5V18.75V18H118.5H121.5V17.25V16.5H118.5H115.5V15.75ZM121.5 20.25V19.5H119.25H117V20.25V21H119.25H121.5V20.25ZM130.5 13.5V12H132H133.5V13.5V15H135H136.5V15.75V16.5H135H133.5V19.5V22.5H132H130.5V19.5V16.5H129H127.5V15.75V15H129H130.5V13.5ZM139.5 15.75V15H143.25H147V15.75V16.5H147.75H148.5V18V19.5H144.75H141V20.25V21H144H147V21.75V22.5H143.25H139.5V21.75V21H138.75H138V18.75V16.5H138.75H139.5V15.75ZM145.5 17.25V16.5H143.25H141V17.25V18H143.25H145.5V17.25ZM55.5 29.75V29H59.25H63V29.75V30.5H60H57V31.25V32H60H63V32.75V33.5H63.75H64.5V34.25V35H63.75H63V35.75V36.5H58.5H54V35.75V35H57.75H61.5V34.25V33.5H58.5H55.5V32.75V32H54.75H54V31.25V30.5H54.75H55.5V29.75ZM67.5 29.75V29H71.25H75V29.75V30.5H75.75H76.5V32.75V35H75.75H75V35.75V36.5H71.25H67.5V35.75V35H66.75H66V32.75V30.5H66.75H67.5V29.75ZM73.5 32.75V30.5H71.25H69V32.75V35H71.25H73.5V32.75ZM78 32V29H79.5H81V32V35H83.25H85.5V32V29H87H88.5V32.75V36.5H84H79.5V35.75V35H78.75H78V32ZM90 32.75V29H94.5H99V29.75V30.5H99.75H100.5V33.5V36.5H99H97.5V33.5V30.5H95.25H93V33.5V36.5H91.5H90V32.75ZM109.5 27.5V26H111H112.5V31.25V36.5H108H103.5V35.75V35H102.75H102V32.75V30.5H102.75H103.5V29.75V29H106.5H109.5V27.5ZM109.5 32.75V30.5H107.25H105V32.75V35H107.25H109.5V32.75Z" fill="#FEF8EA"/>
    <path d="M8 37.6519L10.3323 37.6519L10.3323 39.9841L8 39.9841L8 37.6519Z" fill="#FEF8EA"/>
    <path d="M8 35.3196L10.3323 35.3196L10.3323 37.6519L8 37.6519L8 35.3196Z" fill="#FEF8EA"/>
    <path d="M10.3323 37.6519L12.6646 37.6519L12.6646 39.9841L10.3323 39.9841L10.3323 37.6519Z" fill="#FEF8EA"/>
    <path d="M10.3323 35.3196L12.6646 35.3196L12.6646 37.6519L10.3323 37.6519L10.3323 35.3196Z" fill="#FEF8EA"/>
    <path d="M10.3323 32.9873L12.6646 32.9873L12.6646 35.3196L10.3323 35.3196L10.3323 32.9873Z" fill="#FEF8EA"/>
    <path d="M10.3323 39.9841L12.6646 39.9841L12.6646 42.3164L10.3323 42.3164L10.3323 39.9841Z" fill="#FEF8EA"/>
    <path d="M12.6646 35.3196L14.9968 35.3196L14.9968 37.6519L12.6646 37.6519L12.6646 35.3196Z" fill="#FEF8EA"/>
    <path d="M12.6646 32.9873L14.9968 32.9873L14.9968 35.3196L12.6646 35.3196L12.6646 32.9873Z" fill="#FEF8EA"/>
    <path d="M12.6646 30.655L14.9968 30.655L14.9968 32.9873L12.6646 32.9873L12.6646 30.655Z" fill="#FEF8EA"/>
    <path d="M12.6646 39.9841L14.9968 39.9841L14.9968 42.3164L12.6646 42.3164L12.6646 39.9841Z" fill="#FEF8EA"/>
    <path d="M14.9968 39.9841L17.3291 39.9841L17.3291 42.3164L14.9968 42.3164L14.9968 39.9841Z" fill="#FEF8EA"/>
    <path d="M14.9968 37.6519L17.3291 37.6519L17.3291 39.9841L14.9968 39.9841L14.9968 37.6519Z" fill="#FEF8EA"/>
    <path d="M17.3291 37.6519L19.6614 37.6519L19.6614 39.9841L17.3291 39.9841L17.3291 37.6519Z" fill="#FEF8EA"/>
    <path d="M17.3291 35.3196L19.6614 35.3196L19.6614 37.6519L17.3291 37.6519L17.3291 35.3196Z" fill="#FEF8EA"/>
    <path d="M17.3291 32.9873L19.6614 32.9873L19.6614 35.3196L17.3291 35.3196L17.3291 32.9873Z" fill="#FEF8EA"/>
    <path d="M17.3291 30.655L19.6614 30.655L19.6614 32.9873L17.3291 32.9873L17.3291 30.655Z" fill="#FEF8EA"/>
    <path d="M14.9968 30.655L17.3291 30.655L17.3291 32.9873L14.9968 32.9873L14.9968 30.655Z" fill="#FEF8EA"/>
    <path d="M14.9968 32.9873L17.3291 32.9873L17.3291 35.3196L14.9968 35.3196L14.9968 32.9873Z" fill="#FEF8EA"/>
    <path d="M14.9968 35.3196L17.3291 35.3196L17.3291 37.6519L14.9968 37.6519L14.9968 35.3196Z" fill="#FEF8EA"/>
    <path d="M19.6614 35.3196L21.9937 35.3196L21.9937 37.6519L19.6614 37.6519L19.6614 35.3196Z" fill="#FEF8EA"/>
    <path d="M19.6614 32.9873L21.9937 32.9873L21.9937 35.3196L19.6614 35.3196L19.6614 32.9873Z" fill="#FEF8EA"/>
    <path d="M19.6614 30.655L21.9937 30.655L21.9937 32.9873L19.6614 32.9873L19.6614 30.655Z" fill="#FEF8EA"/>
    <path d="M19.6614 28.3228L21.9937 28.3228L21.9937 30.655L19.6614 30.655L19.6614 28.3228Z" fill="#FEF8EA"/>
    <path d="M19.6614 25.9905L21.9937 25.9905L21.9937 28.3228L19.6614 28.3228L19.6614 25.9905Z" fill="#FEF8EA"/>
    <path d="M19.6614 23.6582L21.9937 23.6582L21.9937 25.9905L19.6614 25.9905L19.6614 23.6582Z" fill="#FEF8EA"/>
    <path d="M19.6614 21.3259L21.9937 21.3259L21.9937 23.6582L19.6614 23.6582L19.6614 21.3259Z" fill="#FEF8EA"/>
    <path d="M19.6614 18.9937L21.9937 18.9937L21.9937 21.3259L19.6614 21.3259L19.6614 18.9937Z" fill="#FEF8EA"/>
    <path d="M19.6614 16.6614L21.9937 16.6614L21.9937 18.9937L19.6614 18.9937L19.6614 16.6614Z" fill="#FEF8EA"/>
    <path d="M19.6614 14.3292L21.9937 14.3292L21.9937 16.6614L19.6614 16.6614L19.6614 14.3292Z" fill="#FEF8EA"/>
    <path d="M19.6614 11.9968L21.9937 11.9968L21.9937 14.3291L19.6614 14.3291L19.6614 11.9968Z" fill="#FEF8EA"/>
    <path d="M19.6614 9.66461L21.9937 9.66461L21.9937 11.9969L19.6614 11.9969L19.6614 9.66461Z" fill="#FEF8EA"/>
    <path d="M19.6614 7.33228L21.9937 7.33228L21.9937 9.66455L19.6614 9.66455L19.6614 7.33228Z" fill="#FEF8EA"/>
    <path d="M21.9938 7.33228L24.326 7.33228L24.3261 9.66455L21.9938 9.66455L21.9938 7.33228Z" fill="#FEF8EA"/>
    <path d="M24.3259 7.33228L26.6582 7.33228L26.6582 9.66455L24.3259 9.66455L24.3259 7.33228Z" fill="#FEF8EA"/>
    <path d="M21.9938 9.66461L24.326 9.66461L24.3261 11.9969L21.9938 11.9969L21.9938 9.66461Z" fill="#FEF8EA"/>
    <path d="M24.3259 9.66461L26.6582 9.66461L26.6582 11.9969L24.3259 11.9969L24.3259 9.66461Z" fill="#FEF8EA"/>
    <path d="M24.3259 11.9968L26.6582 11.9968L26.6582 14.3291L24.3259 14.3291L24.3259 11.9968Z" fill="#FEF8EA"/>
    <path d="M26.6582 11.9968L28.9905 11.9968L28.9905 14.3291L26.6582 14.3291L26.6582 11.9968Z" fill="#FEF8EA"/>
    <path d="M26.6582 14.3292L28.9905 14.3292L28.9905 16.6614L26.6582 16.6614L26.6582 14.3292Z" fill="#FEF8EA"/>
    <path d="M26.6582 9.66461L28.9905 9.66461L28.9905 11.9969L26.6582 11.9969L26.6582 9.66461Z" fill="#FEF8EA"/>
    <path d="M19.6614 5L21.9937 5L21.9937 7.33227L19.6614 7.33227L19.6614 5Z" fill="#FEF8EA"/>
    <path d="M12.6646 37.6519L14.9968 37.6519L14.9968 39.9841L12.6646 39.9841L12.6646 37.6519Z" fill="#FEF8EA"/>
    <path d="M25.492 32.1127L27.0955 32.1127L27.0955 33.7162L25.492 33.7162L25.492 32.1127Z" fill="#FEF8EA"/>
    <path d="M25.492 30.5093L27.0955 30.5093L27.0955 32.1127L25.492 32.1127L25.492 30.5093Z" fill="#FEF8EA"/>
    <path d="M27.0955 32.1127L28.699 32.1127L28.699 33.7162L27.0955 33.7162L27.0955 32.1127Z" fill="#FEF8EA"/>
    <path d="M27.0955 30.5093L28.699 30.5093L28.699 32.1127L27.0955 32.1127L27.0955 30.5093Z" fill="#FEF8EA"/>
    <path d="M27.0955 28.9059L28.699 28.9059L28.699 30.5093L27.0955 30.5093L27.0955 28.9059Z" fill="#FEF8EA"/>
    <path d="M27.0955 33.7161L28.699 33.7161L28.699 35.3196L27.0955 35.3196L27.0955 33.7161Z" fill="#FEF8EA"/>
    <path d="M28.6989 30.5093L30.3024 30.5093L30.3024 32.1127L28.6989 32.1127L28.6989 30.5093Z" fill="#FEF8EA"/>
    <path d="M28.6989 28.9059L30.3024 28.9059L30.3024 30.5093L28.6989 30.5093L28.6989 28.9059Z" fill="#FEF8EA"/>
    <path d="M28.6989 27.3024L30.3024 27.3024L30.3024 28.9058L28.6989 28.9058L28.6989 27.3024Z" fill="#FEF8EA"/>
    <path d="M28.6989 33.7161L30.3024 33.7161L30.3024 35.3196L28.6989 35.3196L28.6989 33.7161Z" fill="#FEF8EA"/>
    <path d="M30.3023 33.7161L31.9058 33.7161L31.9058 35.3196L30.3023 35.3196L30.3023 33.7161Z" fill="#FEF8EA"/>
    <path d="M30.3023 32.1127L31.9058 32.1127L31.9058 33.7162L30.3023 33.7162L30.3023 32.1127Z" fill="#FEF8EA"/>
    <path d="M31.9057 32.1127L33.5092 32.1127L33.5092 33.7162L31.9057 33.7162L31.9057 32.1127Z" fill="#FEF8EA"/>
    <path d="M31.9057 30.5093L33.5092 30.5093L33.5092 32.1127L31.9057 32.1127L31.9057 30.5093Z" fill="#FEF8EA"/>
    <path d="M31.9057 28.9059L33.5092 28.9059L33.5092 30.5093L31.9057 30.5093L31.9057 28.9059Z" fill="#FEF8EA"/>
    <path d="M31.9057 27.3024L33.5092 27.3024L33.5092 28.9058L31.9057 28.9058L31.9057 27.3024Z" fill="#FEF8EA"/>
    <path d="M30.3023 27.3024L31.9058 27.3024L31.9058 28.9058L30.3023 28.9058L30.3023 27.3024Z" fill="#FEF8EA"/>
    <path d="M30.3023 28.9059L31.9058 28.9059L31.9058 30.5093L30.3023 30.5093L30.3023 28.9059Z" fill="#FEF8EA"/>
    <path d="M30.3023 30.5093L31.9058 30.5093L31.9058 32.1127L30.3023 32.1127L30.3023 30.5093Z" fill="#FEF8EA"/>
    <path d="M33.5094 30.5093L35.1128 30.5093L35.1128 32.1127L33.5094 32.1127L33.5094 30.5093Z" fill="#FEF8EA"/>
    <path d="M33.5094 28.9059L35.1128 28.9059L35.1128 30.5093L33.5094 30.5093L33.5094 28.9059Z" fill="#FEF8EA"/>
    <path d="M33.5094 27.3024L35.1128 27.3024L35.1128 28.9058L33.5094 28.9058L33.5094 27.3024Z" fill="#FEF8EA"/>
    <path d="M33.5094 25.6989L35.1128 25.6989L35.1128 27.3024L33.5094 27.3024L33.5094 25.6989Z" fill="#FEF8EA"/>
    <path d="M33.5094 24.0955L35.1128 24.0955L35.1128 25.699L33.5094 25.699L33.5094 24.0955Z" fill="#FEF8EA"/>
    <path d="M33.5094 22.4921L35.1128 22.4921L35.1128 24.0955L33.5094 24.0955L33.5094 22.4921Z" fill="#FEF8EA"/>
    <path d="M33.5094 20.8887L35.1128 20.8887L35.1128 22.4921L33.5094 22.4921L33.5094 20.8887Z" fill="#FEF8EA"/>
    <path d="M33.5094 19.2852L35.1128 19.2852L35.1128 20.8887L33.5094 20.8887L33.5094 19.2852Z" fill="#FEF8EA"/>
    <path d="M33.5094 17.6817L35.1128 17.6817L35.1128 19.2851L33.5094 19.2851L33.5094 17.6817Z" fill="#FEF8EA"/>
    <path d="M33.5094 16.0783L35.1128 16.0783L35.1128 17.6817L33.5094 17.6817L33.5094 16.0783Z" fill="#FEF8EA"/>
    <path d="M33.5094 14.4749L35.1128 14.4749L35.1128 16.0783L33.5094 16.0783L33.5094 14.4749Z" fill="#FEF8EA"/>
    <path d="M33.5094 12.8715L35.1128 12.8715L35.1128 14.4749L33.5094 14.4749L33.5094 12.8715Z" fill="#FEF8EA"/>
    <path d="M33.5094 11.268L35.1128 11.268L35.1128 12.8714L33.5094 12.8714L33.5094 11.268Z" fill="#FEF8EA"/>
    <path d="M35.1127 11.268L36.7162 11.268L36.7162 12.8714L35.1127 12.8714L35.1127 11.268Z" fill="#FEF8EA"/>
    <path d="M36.7161 11.268L38.3196 11.268L38.3196 12.8714L36.7161 12.8714L36.7161 11.268Z" fill="#FEF8EA"/>
    <path d="M35.1127 12.8715L36.7162 12.8715L36.7162 14.4749L35.1127 14.4749L35.1127 12.8715Z" fill="#FEF8EA"/>
    <path d="M36.7161 12.8715L38.3196 12.8715L38.3196 14.4749L36.7161 14.4749L36.7161 12.8715Z" fill="#FEF8EA"/>
    <path d="M36.7161 14.4749L38.3196 14.4749L38.3196 16.0783L36.7161 16.0783L36.7161 14.4749Z" fill="#FEF8EA"/>
    <path d="M38.3197 14.4749L39.9231 14.4749L39.9231 16.0783L38.3197 16.0783L38.3197 14.4749Z" fill="#FEF8EA"/>
    <path d="M38.3197 16.0783L39.9231 16.0783L39.9231 17.6817L38.3197 17.6817L38.3197 16.0783Z" fill="#FEF8EA"/>
    <path d="M38.3197 12.8715L39.9231 12.8715L39.9231 14.4749L38.3197 14.4749L38.3197 12.8715Z" fill="#FEF8EA"/>
    <path d="M33.5094 9.66461L35.1128 9.66461L35.1128 11.2681L33.5094 11.2681L33.5094 9.66461Z" fill="#FEF8EA"/>
    <path d="M28.6989 32.1127L30.3024 32.1127L30.3024 33.7162L28.6989 33.7162L28.6989 32.1127Z" fill="#FEF8EA"/>
    </svg>`;
  }

  pause() {
    return `<svg width="114" height="48" viewBox="0 0 114 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M54 17.25V12H55.5H57V12.75V13.5H57.75H58.5V14.25V15H59.25H60V14.25V13.5H60.75H61.5V12.75V12H63H64.5V17.25V22.5H63H61.5V20.25V18H60.75H60V18.75V19.5H59.25H58.5V18.75V18H57.75H57V20.25V22.5H55.5H54V17.25ZM66 18V15H67.5H69V18V21H71.25H73.5V18V15H75H76.5V18.75V22.5H72H67.5V21.75V21H66.75H66V18ZM82.5 13.5V12H84H85.5V13.5V15H87H88.5V15.75V16.5H87H85.5V19.5V22.5H84H82.5V19.5V16.5H81H79.5V15.75V15H81H82.5V13.5ZM91.5 15.75V15H95.25H99V15.75V16.5H99.75H100.5V18V19.5H96.75H93V20.25V21H96H99V21.75V22.5H95.25H91.5V21.75V21H90.75H90V18.75V16.5H90.75H91.5V15.75ZM97.5 17.25V16.5H95.25H93V17.25V18H95.25H97.5V17.25ZM55.5 29.75V29H59.25H63V29.75V30.5H60H57V31.25V32H60H63V32.75V33.5H63.75H64.5V34.25V35H63.75H63V35.75V36.5H58.5H54V35.75V35H57.75H61.5V34.25V33.5H58.5H55.5V32.75V32H54.75H54V31.25V30.5H54.75H55.5V29.75ZM67.5 29.75V29H71.25H75V29.75V30.5H75.75H76.5V32.75V35H75.75H75V35.75V36.5H71.25H67.5V35.75V35H66.75H66V32.75V30.5H66.75H67.5V29.75ZM73.5 32.75V30.5H71.25H69V32.75V35H71.25H73.5V32.75ZM78 32V29H79.5H81V32V35H83.25H85.5V32V29H87H88.5V32.75V36.5H84H79.5V35.75V35H78.75H78V32ZM90 32.75V29H94.5H99V29.75V30.5H99.75H100.5V33.5V36.5H99H97.5V33.5V30.5H95.25H93V33.5V36.5H91.5H90V32.75ZM109.5 27.5V26H111H112.5V31.25V36.5H108H103.5V35.75V35H102.75H102V32.75V30.5H102.75H103.5V29.75V29H106.5H109.5V27.5ZM109.5 32.75V30.5H107.25H105V32.75V35H107.25H109.5V32.75Z" fill="#FEF8EA"/>
    <path d="M8.16614 37.6518L10.4984 37.6518L10.4984 39.9841L8.16614 39.9841L8.16614 37.6518Z" fill="#FEF8EA"/>
    <path d="M8.16614 35.3196L10.4984 35.3196L10.4984 37.6519L8.16614 37.6519L8.16614 35.3196Z" fill="#FEF8EA"/>
    <path d="M10.4984 37.6518L12.8307 37.6518L12.8307 39.9841L10.4984 39.9841L10.4984 37.6518Z" fill="#FEF8EA"/>
    <path d="M10.4984 35.3196L12.8307 35.3196L12.8307 37.6519L10.4984 37.6519L10.4984 35.3196Z" fill="#FEF8EA"/>
    <path d="M10.4984 32.9873L12.8307 32.9873L12.8307 35.3196L10.4984 35.3196L10.4984 32.9873Z" fill="#FEF8EA"/>
    <path d="M10.4984 39.9841L12.8307 39.9841L12.8307 42.3164L10.4984 42.3164L10.4984 39.9841Z" fill="#FEF8EA"/>
    <path d="M12.8307 35.3196L15.163 35.3196L15.163 37.6519L12.8307 37.6519L12.8307 35.3196Z" fill="#FEF8EA"/>
    <path d="M12.8307 32.9873L15.163 32.9873L15.163 35.3196L12.8307 35.3196L12.8307 32.9873Z" fill="#FEF8EA"/>
    <path d="M12.8307 30.655L15.163 30.655L15.163 32.9873L12.8307 32.9873L12.8307 30.655Z" fill="#FEF8EA"/>
    <path d="M12.8307 39.9841L15.163 39.9841L15.163 42.3164L12.8307 42.3164L12.8307 39.9841Z" fill="#FEF8EA"/>
    <path d="M15.163 39.9841L17.4952 39.9841L17.4952 42.3164L15.163 42.3164L15.163 39.9841Z" fill="#FEF8EA"/>
    <path d="M15.163 37.6518L17.4952 37.6518L17.4952 39.9841L15.163 39.9841L15.163 37.6518Z" fill="#FEF8EA"/>
    <path d="M17.4951 37.6518L19.8274 37.6518L19.8274 39.9841L17.4951 39.9841L17.4951 37.6518Z" fill="#FEF8EA"/>
    <path d="M17.4951 35.3196L19.8274 35.3196L19.8274 37.6519L17.4951 37.6519L17.4951 35.3196Z" fill="#FEF8EA"/>
    <path d="M17.4951 32.9873L19.8274 32.9873L19.8274 35.3196L17.4951 35.3196L17.4951 32.9873Z" fill="#FEF8EA"/>
    <path d="M17.4951 30.655L19.8274 30.655L19.8274 32.9873L17.4951 32.9873L17.4951 30.655Z" fill="#FEF8EA"/>
    <path d="M15.163 30.655L17.4952 30.655L17.4952 32.9873L15.163 32.9873L15.163 30.655Z" fill="#FEF8EA"/>
    <path d="M15.163 32.9873L17.4952 32.9873L17.4952 35.3196L15.163 35.3196L15.163 32.9873Z" fill="#FEF8EA"/>
    <path d="M15.163 35.3196L17.4952 35.3196L17.4952 37.6519L15.163 37.6519L15.163 35.3196Z" fill="#FEF8EA"/>
    <path d="M19.8275 35.3196L22.1598 35.3196L22.1598 37.6519L19.8275 37.6519L19.8275 35.3196Z" fill="#FEF8EA"/>
    <path d="M19.8275 32.9873L22.1598 32.9873L22.1598 35.3196L19.8275 35.3196L19.8275 32.9873Z" fill="#FEF8EA"/>
    <path d="M19.8275 30.655L22.1598 30.655L22.1598 32.9873L19.8275 32.9873L19.8275 30.655Z" fill="#FEF8EA"/>
    <path d="M19.8275 28.3228L22.1598 28.3228L22.1598 30.655L19.8275 30.655L19.8275 28.3228Z" fill="#FEF8EA"/>
    <path d="M19.8275 25.9905L22.1598 25.9905L22.1598 28.3228L19.8275 28.3228L19.8275 25.9905Z" fill="#FEF8EA"/>
    <path d="M19.8275 23.6582L22.1598 23.6582L22.1598 25.9905L19.8275 25.9905L19.8275 23.6582Z" fill="#FEF8EA"/>
    <path d="M19.8275 21.3259L22.1598 21.3259L22.1598 23.6582L19.8275 23.6582L19.8275 21.3259Z" fill="#FEF8EA"/>
    <path d="M7 7.33228L9.33228 7.33228L9.33228 9.66455L7 9.66455L7 7.33228Z" fill="#FEF8EA"/>
    <path d="M9.33228 9.66461L11.6646 9.66461L11.6646 11.9969L9.33228 11.9969L9.33228 9.66461Z" fill="#FEF8EA"/>
    <path d="M11.6647 11.9968L13.9969 11.9968L13.9969 14.3291L11.6647 14.3291L11.6647 11.9968Z" fill="#FEF8EA"/>
    <path d="M13.9968 14.3292L16.3291 14.3292L16.3291 16.6614L13.9968 16.6614L13.9968 14.3292Z" fill="#FEF8EA"/>
    <path d="M16.3291 16.6614L18.6614 16.6614L18.6614 18.9937L16.3291 18.9937L16.3291 16.6614Z" fill="#FEF8EA"/>
    <path d="M18.6614 18.9937L20.9937 18.9937L20.9937 21.3259L18.6614 21.3259L18.6614 18.9937Z" fill="#FEF8EA"/>
    <path d="M20.9937 21.3259L23.3259 21.3259L23.3259 23.6582L20.9937 23.6582L20.9937 21.3259Z" fill="#FEF8EA"/>
    <path d="M23.3258 23.6582L25.6581 23.6582L25.6581 25.9905L23.3258 25.9905L23.3258 23.6582Z" fill="#FEF8EA"/>
    <path d="M25.6582 25.9905L27.9905 25.9905L27.9905 28.3228L25.6582 28.3228L25.6582 25.9905Z" fill="#FEF8EA"/>
    <path d="M27.9905 28.3228L30.3228 28.3228L30.3228 30.655L27.9905 30.655L27.9905 28.3228Z" fill="#FEF8EA"/>
    <path d="M30.3228 30.655L32.655 30.655L32.655 32.9873L30.3228 32.9873L30.3228 30.655Z" fill="#FEF8EA"/>
    <path d="M32.655 32.9873L34.9873 32.9873L34.9873 35.3196L32.655 35.3196L32.655 32.9873Z" fill="#FEF8EA"/>
    <path d="M34.9873 35.3196L37.3196 35.3196L37.3196 37.6519L34.9873 37.6519L34.9873 35.3196Z" fill="#FEF8EA"/>
    <path d="M37.3196 37.6518L39.6519 37.6518L39.6519 39.9841L37.3196 39.9841L37.3196 37.6518Z" fill="#FEF8EA"/>
    <path d="M39.6519 39.9841L41.9841 39.9841L41.9841 42.3164L39.6519 42.3164L39.6519 39.9841Z" fill="#FEF8EA"/>
    <path d="M19.8275 18.9937L22.1598 18.9937L22.1598 21.3259L19.8275 21.3259L19.8275 18.9937Z" fill="#FEF8EA"/>
    <path d="M19.8275 16.6614L22.1598 16.6614L22.1598 18.9937L19.8275 18.9937L19.8275 16.6614Z" fill="#FEF8EA"/>
    <path d="M19.8275 14.3292L22.1598 14.3292L22.1598 16.6614L19.8275 16.6614L19.8275 14.3292Z" fill="#FEF8EA"/>
    <path d="M19.8275 11.9968L22.1598 11.9968L22.1598 14.3291L19.8275 14.3291L19.8275 11.9968Z" fill="#FEF8EA"/>
    <path d="M19.8275 9.66461L22.1598 9.66461L22.1598 11.9969L19.8275 11.9969L19.8275 9.66461Z" fill="#FEF8EA"/>
    <path d="M19.8275 7.33228L22.1598 7.33228L22.1598 9.66455L19.8275 9.66455L19.8275 7.33228Z" fill="#FEF8EA"/>
    <path d="M22.1598 7.33228L24.4921 7.33228L24.4921 9.66455L22.1598 9.66455L22.1598 7.33228Z" fill="#FEF8EA"/>
    <path d="M24.4921 7.33228L26.8243 7.33228L26.8243 9.66455L24.4921 9.66455L24.4921 7.33228Z" fill="#FEF8EA"/>
    <path d="M22.1598 9.66461L24.4921 9.66461L24.4921 11.9969L22.1598 11.9969L22.1598 9.66461Z" fill="#FEF8EA"/>
    <path d="M24.4921 9.66461L26.8243 9.66461L26.8243 11.9969L24.4921 11.9969L24.4921 9.66461Z" fill="#FEF8EA"/>
    <path d="M24.4921 11.9968L26.8243 11.9968L26.8243 14.3291L24.4921 14.3291L24.4921 11.9968Z" fill="#FEF8EA"/>
    <path d="M26.8243 11.9968L29.1566 11.9968L29.1566 14.3291L26.8243 14.3291L26.8243 11.9968Z" fill="#FEF8EA"/>
    <path d="M26.8243 14.3292L29.1566 14.3292L29.1566 16.6614L26.8243 16.6614L26.8243 14.3292Z" fill="#FEF8EA"/>
    <path d="M26.8243 9.66461L29.1566 9.66461L29.1566 11.9969L26.8243 11.9969L26.8243 9.66461Z" fill="#FEF8EA"/>
    <path d="M19.8275 5L22.1598 5L22.1598 7.33227L19.8275 7.33227L19.8275 5Z" fill="#FEF8EA"/>
    <path d="M12.8307 37.6518L15.163 37.6518L15.163 39.9841L12.8307 39.9841L12.8307 37.6518Z" fill="#FEF8EA"/>
    <path d="M25.6583 32.1127L27.2617 32.1127L27.2617 33.7162L25.6583 33.7162L25.6583 32.1127Z" fill="#FEF8EA"/>
    <path d="M25.6583 30.5093L27.2617 30.5093L27.2617 32.1127L25.6583 32.1127L25.6583 30.5093Z" fill="#FEF8EA"/>
    <path d="M27.2617 32.1127L28.8651 32.1127L28.8651 33.7162L27.2617 33.7162L27.2617 32.1127Z" fill="#FEF8EA"/>
    <path d="M27.2617 30.5093L28.8651 30.5093L28.8651 32.1127L27.2617 32.1127L27.2617 30.5093Z" fill="#FEF8EA"/>
    <path d="M27.2617 28.9059L28.8651 28.9059L28.8651 30.5093L27.2617 30.5093L27.2617 28.9059Z" fill="#FEF8EA"/>
    <path d="M27.2617 33.7161L28.8651 33.7161L28.8651 35.3196L27.2617 35.3196L27.2617 33.7161Z" fill="#FEF8EA"/>
    <path d="M28.8651 30.5093L30.4685 30.5093L30.4685 32.1127L28.8651 32.1127L28.8651 30.5093Z" fill="#FEF8EA"/>
    <path d="M28.8651 28.9059L30.4685 28.9059L30.4685 30.5093L28.8651 30.5093L28.8651 28.9059Z" fill="#FEF8EA"/>
    <path d="M28.8651 27.3024L30.4685 27.3024L30.4685 28.9058L28.8651 28.9058L28.8651 27.3024Z" fill="#FEF8EA"/>
    <path d="M28.8651 33.7161L30.4685 33.7161L30.4685 35.3196L28.8651 35.3196L28.8651 33.7161Z" fill="#FEF8EA"/>
    <path d="M30.4686 33.7161L32.072 33.7161L32.072 35.3196L30.4686 35.3196L30.4686 33.7161Z" fill="#FEF8EA"/>
    <path d="M30.4686 32.1127L32.072 32.1127L32.072 33.7162L30.4686 33.7162L30.4686 32.1127Z" fill="#FEF8EA"/>
    <path d="M32.072 32.1127L33.6754 32.1127L33.6754 33.7162L32.072 33.7162L32.072 32.1127Z" fill="#FEF8EA"/>
    <path d="M32.072 30.5093L33.6754 30.5093L33.6754 32.1127L32.072 32.1127L32.072 30.5093Z" fill="#FEF8EA"/>
    <path d="M32.072 28.9059L33.6754 28.9059L33.6754 30.5093L32.072 30.5093L32.072 28.9059Z" fill="#FEF8EA"/>
    <path d="M32.072 27.3024L33.6754 27.3024L33.6754 28.9058L32.072 28.9058L32.072 27.3024Z" fill="#FEF8EA"/>
    <path d="M30.4686 27.3024L32.072 27.3024L32.072 28.9058L30.4686 28.9058L30.4686 27.3024Z" fill="#FEF8EA"/>
    <path d="M30.4686 28.9059L32.072 28.9059L32.072 30.5093L30.4686 30.5093L30.4686 28.9059Z" fill="#FEF8EA"/>
    <path d="M30.4686 30.5093L32.072 30.5093L32.072 32.1127L30.4686 32.1127L30.4686 30.5093Z" fill="#FEF8EA"/>
    <path d="M33.6754 30.5093L35.2788 30.5093L35.2788 32.1127L33.6754 32.1127L33.6754 30.5093Z" fill="#FEF8EA"/>
    <path d="M33.6754 28.9059L35.2788 28.9059L35.2788 30.5093L33.6754 30.5093L33.6754 28.9059Z" fill="#FEF8EA"/>
    <path d="M33.6754 27.3024L35.2788 27.3024L35.2788 28.9058L33.6754 28.9058L33.6754 27.3024Z" fill="#FEF8EA"/>
    <path d="M33.6754 25.6989L35.2788 25.6989L35.2788 27.3024L33.6754 27.3024L33.6754 25.6989Z" fill="#FEF8EA"/>
    <path d="M33.6754 24.0955L35.2788 24.0955L35.2788 25.699L33.6754 25.699L33.6754 24.0955Z" fill="#FEF8EA"/>
    <path d="M33.6754 22.4921L35.2788 22.4921L35.2788 24.0955L33.6754 24.0955L33.6754 22.4921Z" fill="#FEF8EA"/>
    <path d="M33.6754 20.8887L35.2788 20.8887L35.2788 22.4921L33.6754 22.4921L33.6754 20.8887Z" fill="#FEF8EA"/>
    <path d="M33.6754 19.2852L35.2788 19.2852L35.2788 20.8887L33.6754 20.8887L33.6754 19.2852Z" fill="#FEF8EA"/>
    <path d="M33.6754 17.6817L35.2788 17.6817L35.2788 19.2851L33.6754 19.2851L33.6754 17.6817Z" fill="#FEF8EA"/>
    <path d="M33.6754 16.0783L35.2788 16.0783L35.2788 17.6817L33.6754 17.6817L33.6754 16.0783Z" fill="#FEF8EA"/>
    <path d="M33.6754 14.4749L35.2788 14.4749L35.2788 16.0783L33.6754 16.0783L33.6754 14.4749Z" fill="#FEF8EA"/>
    <path d="M33.6754 12.8715L35.2788 12.8715L35.2788 14.4749L33.6754 14.4749L33.6754 12.8715Z" fill="#FEF8EA"/>
    <path d="M33.6754 11.268L35.2788 11.268L35.2788 12.8714L33.6754 12.8714L33.6754 11.268Z" fill="#FEF8EA"/>
    <path d="M35.2789 11.268L36.8823 11.268L36.8823 12.8714L35.2789 12.8714L35.2789 11.268Z" fill="#FEF8EA"/>
    <path d="M36.8823 11.268L38.4857 11.268L38.4857 12.8714L36.8823 12.8714L36.8823 11.268Z" fill="#FEF8EA"/>
    <path d="M35.2789 12.8715L36.8823 12.8715L36.8823 14.4749L35.2789 14.4749L35.2789 12.8715Z" fill="#FEF8EA"/>
    <path d="M36.8823 12.8715L38.4857 12.8715L38.4857 14.4749L36.8823 14.4749L36.8823 12.8715Z" fill="#FEF8EA"/>
    <path d="M36.8823 14.4749L38.4857 14.4749L38.4857 16.0783L36.8823 16.0783L36.8823 14.4749Z" fill="#FEF8EA"/>
    <path d="M38.4857 14.4749L40.0891 14.4749L40.0891 16.0783L38.4857 16.0783L38.4857 14.4749Z" fill="#FEF8EA"/>
    <path d="M38.4857 16.0783L40.0891 16.0783L40.0891 17.6817L38.4857 17.6817L38.4857 16.0783Z" fill="#FEF8EA"/>
    <path d="M38.4857 12.8715L40.0891 12.8715L40.0891 14.4749L38.4857 14.4749L38.4857 12.8715Z" fill="#FEF8EA"/>
    <path d="M33.6754 9.66461L35.2788 9.66461L35.2788 11.2681L33.6754 11.2681L33.6754 9.66461Z" fill="#FEF8EA"/>
    <path d="M28.8651 32.1127L30.4685 32.1127L30.4685 33.7162L28.8651 33.7162L28.8651 32.1127Z" fill="#FEF8EA"/>
    </svg>`;
  }

  boy1() {
    return `<svg width="78" height="132" viewBox="0 0 78 132" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72 66H66V72H72V66Z" fill="#F4D5B8"/>
    <path d="M72 60H66V66H72V60Z" fill="#F4D5B8"/>
    <path d="M72 54H66V60H72V54Z" fill="#F4D5B8"/>
    <path d="M66 72H60V78H66V72Z" fill="#F4D5B8"/>
    <path d="M66 66H60V72H66V66Z" fill="#F4D5B8"/>
    <path d="M66 60H60V66H66V60Z" fill="#F4D5B8"/>
    <path d="M66 54H60V60H66V54Z" fill="#F4D5B8"/>
    <path d="M66 48H60V54H66V48Z" fill="#F4D5B8"/>
    <path d="M66 42H60V48H66V42Z" fill="#F4D5B8"/>
    <path d="M66 36H60V42H66V36Z" fill="#F4D5B8"/>
    <path d="M60 72H54V78H60V72Z" fill="#F4D5B8"/>
    <path d="M60 66H54V72H60V66Z" fill="#F4D5B8"/>
    <path d="M60 60H54V66H60V60Z" fill="#F4D5B8"/>
    <path d="M60 54H54V60H60V54Z" fill="#F4D5B8"/>
    <path d="M60 48H54V54H60V48Z" fill="#F4D5B8"/>
    <path d="M60 42H54V48H60V42Z" fill="#F4D5B8"/>
    <path d="M60 36H54V42H60V36Z" fill="#F4D5B8"/>
    <path d="M60 30H54V36H60V30Z" fill="#F4D5B8"/>
    <path d="M54 72H48V78H54V72Z" fill="#F4D5B8"/>
    <path d="M54 66H48V72H54V66Z" fill="#F4D5B8"/>
    <path d="M54 60H48V66H54V60Z" fill="#F4D5B8"/>
    <path d="M54 54H48V60H54V54Z" fill="#F4D5B8"/>
    <path d="M54 48H48V54H54V48Z" fill="#F4D5B8"/>
    <path d="M54 42H48V48H54V42Z" fill="#F4D5B8"/>
    <path d="M54 36H48V42H54V36Z" fill="#F4D5B8"/>
    <path d="M54 30H48V36H54V30Z" fill="#F4D5B8"/>
    <path d="M48 72H42V78H48V72Z" fill="#F4D5B8"/>
    <path d="M48 66H42V72H48V66Z" fill="#F4D5B8"/>
    <path d="M48 60H42V66H48V60Z" fill="#F4D5B8"/>
    <path d="M48 54H42V60H48V54Z" fill="#F4D5B8"/>
    <path d="M48 48H42V54H48V48Z" fill="#F4D5B8"/>
    <path d="M48 42H42V48H48V42Z" fill="#F4D5B8"/>
    <path d="M48 36H42V42H48V36Z" fill="#F4D5B8"/>
    <path d="M48 30H42V36H48V30Z" fill="#F4D5B8"/>
    <path d="M42 72H36V78H42V72Z" fill="#F4D5B8"/>
    <path d="M42 66H36V72H42V66Z" fill="#F4D5B8"/>
    <path d="M42 60H36V66H42V60Z" fill="#F4D5B8"/>
    <path d="M42 54H36V60H42V54Z" fill="#F4D5B8"/>
    <path d="M42 48H36V54H42V48Z" fill="#F4D5B8"/>
    <path d="M42 42H36V48H42V42Z" fill="#F4D5B8"/>
    <path d="M42 36H36V42H42V36Z" fill="#F4D5B8"/>
    <path d="M42 30H36V36H42V30Z" fill="#F4D5B8"/>
    <path d="M36 72H30V78H36V72Z" fill="#F4D5B8"/>
    <path d="M36 66H30V72H36V66Z" fill="#F4D5B8"/>
    <path d="M36 60H30V66H36V60Z" fill="#F4D5B8"/>
    <path d="M36 54H30V60H36V54Z" fill="#F4D5B8"/>
    <path d="M36 48H30V54H36V48Z" fill="#F4D5B8"/>
    <path d="M36 42H30V48H36V42Z" fill="#F4D5B8"/>
    <path d="M36 36H30V42H36V36Z" fill="#F4D5B8"/>
    <path d="M36 30H30V36H36V30Z" fill="#F4D5B8"/>
    <path d="M30 72H24V78H30V72Z" fill="#F4D5B8"/>
    <path d="M30 66H24V72H30V66Z" fill="#F4D5B8"/>
    <path d="M30 60H24V66H30V60Z" fill="#F4D5B8"/>
    <path d="M30 54H24V60H30V54Z" fill="#F4D5B8"/>
    <path d="M30 48H24V54H30V48Z" fill="#F4D5B8"/>
    <path d="M30 42H24V48H30V42Z" fill="#F4D5B8"/>
    <path d="M30 36H24V42H30V36Z" fill="#F4D5B8"/>
    <path d="M30 30H24V36H30V30Z" fill="#F4D5B8"/>
    <path d="M24 66H18V72H24V66Z" fill="#F4D5B8"/>
    <path d="M24 60H18V66H24V60Z" fill="#F4D5B8"/>
    <path d="M24 54H18V60H24V54Z" fill="#F4D5B8"/>
    <path d="M24 48H18V54H24V48Z" fill="#F4D5B8"/>
    <path d="M24 42H18V48H24V42Z" fill="#F4D5B8"/>
    <path d="M24 36H18V42H24V36Z" fill="#F4D5B8"/>
    <path d="M60 54H54V60H60V54Z" fill="#353433"/>
    <path d="M60 48H54V54H60V48Z" fill="#353433"/>
    <path d="M36 54H30V60H36V54Z" fill="#353433"/>
    <path d="M36 48H30V54H36V48Z" fill="#353433"/>
    <path d="M78 102H72V108H78V102Z" fill="#F4D5B8"/>
    <path d="M78 96H72V102H78V96Z" fill="#F4D5B8"/>
    <path d="M72 102H66V108H72V102Z" fill="#F4D5B8"/>
    <path d="M72 96H66V102H72V96Z" fill="#F4D5B8"/>
    <path d="M66 96H60V102H66V96Z" fill="#E5A54A"/>
    <path d="M66 90H60V96H66V90Z" fill="#E5A54A"/>
    <path d="M60 108H54V114H60V108Z" fill="#49545B"/>
    <path d="M60 96H54V102H60V96Z" fill="#D89341"/>
    <path d="M60 90H54V96H60V90Z" fill="#E5A54A"/>
    <path d="M60 84H54V90H60V84Z" fill="#E5A54A"/>
    <path d="M54 108H48V114H54V108Z" fill="#49545B"/>
    <path d="M54 102H48V108H54V102Z" fill="#E5A54A"/>
    <path d="M54 96H48V102H54V96Z" fill="#E5A54A"/>
    <path d="M54 90H48V96H54V90Z" fill="#E5A54A"/>
    <path d="M54 84H48V90H54V84Z" fill="#E5A54A"/>
    <path d="M54 78H48V84H54V78Z" fill="#E5A54A"/>
    <path d="M48 108H42V114H48V108Z" fill="#49545B"/>
    <path d="M48 102H42V108H48V102Z" fill="#E5A54A"/>
    <path d="M48 96H42V102H48V96Z" fill="#E5A54A"/>
    <path d="M48 90H42V96H48V90Z" fill="#E5A54A"/>
    <path d="M48 84H42V90H48V84Z" fill="#E5A54A"/>
    <path d="M48 78H42V84H48V78Z" fill="#E5A54A"/>
    <path d="M42 108H36V114H42V108Z" fill="#49545B"/>
    <path d="M42 102H36V108H42V102Z" fill="#E5A54A"/>
    <path d="M42 96H36V102H42V96Z" fill="#E5A54A"/>
    <path d="M42 90H36V96H42V90Z" fill="#E5A54A"/>
    <path d="M42 84H36V90H42V84Z" fill="#E5A54A"/>
    <path d="M42 78H36V84H42V78Z" fill="#E5A54A"/>
    <path d="M36 120H30V126H36V120Z" fill="#49545B"/>
    <path d="M36 114H30V120H36V114Z" fill="#49545B"/>
    <path d="M36 108H30V114H36V108Z" fill="#49545B"/>
    <path d="M36 102H30V108H36V102Z" fill="#D89341"/>
    <path d="M36 96H30V102H36V96Z" fill="#D89341"/>
    <path d="M36 90H30V96H36V90Z" fill="#D89341"/>
    <path d="M36 84H30V90H36V84Z" fill="#E5A54A"/>
    <path d="M36 78H30V84H36V78Z" fill="#E5A54A"/>
    <path d="M30 84H24V90H30V84Z" fill="#E5A54A"/>
    <path d="M30 78H24V84H30V78Z" fill="#E5A54A"/>
    <path d="M24 84H18V90H24V84Z" fill="#E5A54A"/>
    <path d="M24 78H18V84H24V78Z" fill="#E5A54A"/>
    <path d="M18 78H12V84H18V78Z" fill="#E5A54A"/>
    <path d="M18 72H12V78H18V72Z" fill="#E5A54A"/>
    <path d="M12 78H6V84H12V78Z" fill="#E5A54A"/>
    <path d="M12 72H6V78H12V72Z" fill="#E5A54A"/>
    <path d="M12 66H6V72H12V66Z" fill="#F4D5B8"/>
    <path d="M12 60H6V66H12V60Z" fill="#F4D5B8"/>
    <path d="M6 72H0V78H6V72Z" fill="#E5A54A"/>
    <path d="M6 66H0V72H6V66Z" fill="#F4D5B8"/>
    <path d="M6 60H0V66H6V60Z" fill="#F4D5B8"/>
    <path d="M72 36H66V42H72V36Z" fill="#3A3A3A"/>
    <path d="M66 126H60V132H66V126Z" fill="#9E6C43"/>
    <path d="M66 36H60V42H66V36Z" fill="#3A3A3A"/>
    <path d="M66 30H60V36H66V30Z" fill="#3A3A3A"/>
    <path d="M60 126H54V132H60V126Z" fill="#9E6C43"/>
    <path d="M60 120H54V126H60V120Z" fill="#9E6C43"/>
    <path d="M60 114H54V120H60V114Z" fill="#6A7277"/>
    <path d="M60 108H54V114H60V108Z" fill="#6A7277"/>
    <path d="M60 36H54V42H60V36Z" fill="#3A3A3A"/>
    <path d="M60 30H54V36H60V30Z" fill="#3A3A3A"/>
    <path d="M60 24H54V30H60V24Z" fill="#3A3A3A"/>
    <path d="M54 108H48V114H54V108Z" fill="#6A7277"/>
    <path d="M54 60H48V66H54V60Z" fill="#F7F5F0"/>
    <path d="M54 36H48V42H54V36Z" fill="#3A3A3A"/>
    <path d="M54 30H48V36H54V30Z" fill="#3A3A3A"/>
    <path d="M54 24H48V30H54V24Z" fill="#3A3A3A"/>
    <path d="M54 18H48V24H54V18Z" fill="#F7F5F0"/>
    <path d="M54 12H48V18H54V12Z" fill="#F7F5F0"/>
    <path d="M48 108H42V114H48V108Z" fill="#6A7277"/>
    <path d="M48 60H42V66H48V60Z" fill="#F7F5F0"/>
    <path d="M48 36H42V42H48V36Z" fill="#3A3A3A"/>
    <path d="M48 30H42V36H48V30Z" fill="#3A3A3A"/>
    <path d="M48 24H42V30H48V24Z" fill="#F7F5F0"/>
    <path d="M48 18H42V24H48V18Z" fill="#F7F5F0"/>
    <path d="M48 12H42V18H48V12Z" fill="#F7F5F0"/>
    <path d="M42 60H36V66H42V60Z" fill="#F7F5F0"/>
    <path d="M42 36H36V42H42V36Z" fill="#3A3A3A"/>
    <path d="M42 30H36V36H42V30Z" fill="#3A3A3A"/>
    <path d="M42 24H36V30H42V24Z" fill="#F7F5F0"/>
    <path d="M42 18H36V24H42V18Z" fill="#F7F5F0"/>
    <path d="M42 12H36V18H42V12Z" fill="#F42F47"/>
    <path d="M42 6H36V12H42V6Z" fill="#F42F47"/>
    <path d="M36 36H30V42H36V36Z" fill="#3A3A3A"/>
    <path d="M36 30H30V36H36V30Z" fill="#3A3A3A"/>
    <path d="M36 24H30V30H36V24Z" fill="#F7F5F0"/>
    <path d="M36 18H30V24H36V18Z" fill="#F7F5F0"/>
    <path d="M36 12H30V18H36V12Z" fill="#E51727"/>
    <path d="M36 6H30V12H36V6Z" fill="#F42F47"/>
    <path d="M30 120H24V126H30V120Z" fill="#9E6C43"/>
    <path d="M30 84H24V90H30V84Z" fill="#D89341"/>
    <path d="M30 36H24V42H30V36Z" fill="#3A3A3A"/>
    <path d="M30 30H24V36H30V30Z" fill="#3A3A3A"/>
    <path d="M30 24H24V30H30V24Z" fill="#DDC5C6"/>
    <path d="M30 18H24V24H30V18Z" fill="#E51727"/>
    <path d="M30 12H24V18H30V12Z" fill="#E51727"/>
    <path d="M30 6H24V12H30V6Z" fill="#F42F47"/>
    <path d="M24 126H18V132H24V126Z" fill="#9E6C43"/>
    <path d="M24 120H18V126H24V120Z" fill="#9E6C43"/>
    <path d="M24 84H18V90H24V84Z" fill="#D89341"/>
    <path d="M24 60H18V66H24V60Z" fill="#3A3A3A"/>
    <path d="M24 48H18V54H24V48Z" fill="#3A3A3A"/>
    <path d="M24 42H18V48H24V42Z" fill="#3A3A3A"/>
    <path d="M24 36H18V42H24V36Z" fill="#3A3A3A"/>
    <path d="M24 30H18V36H24V30Z" fill="#DDC5C6"/>
    <path d="M24 24H18V30H24V24Z" fill="#DDC5C6"/>
    <path d="M24 18H18V24H24V18Z" fill="#E51727"/>
    <path d="M24 12H18V18H24V12Z" fill="#E51727"/>
    <path d="M24 6H18V12H24V6Z" fill="#F42F47"/>
    <path d="M18 78H12V84H18V78Z" fill="#D89341"/>
    <path d="M18 30H12V36H18V30Z" fill="#DDC5C6"/>
    <path d="M18 24H12V30H18V24Z" fill="#BC0020"/>
    <path d="M18 18H12V24H18V18Z" fill="#BC0020"/>
    <path d="M18 12H12V18H18V12Z" fill="#BC0020"/>
    <path d="M18 6H12V12H18V6Z" fill="#F42F47"/>
    <path d="M12 78H6V84H12V78Z" fill="#D89341"/>
    <path d="M12 6H6V12H12V6Z" fill="#F42F47"/>
    <path d="M12 0H6V6H12V0Z" fill="#F7F5F0"/>
    <path d="M6 72H0V78H6V72Z" fill="#D89341"/>
    <path d="M6 6H0V12H6V6Z" fill="#F7F5F0"/>
    <path d="M6 0H0V6H6V0Z" fill="#F7F5F0"/>
    </svg>`;
  }

  boy2() {
    return `<svg width="70" height="100" viewBox="0 0 70 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M55 40H50V45H55V40Z" fill="#F4D5B8"/>
    <path d="M55 35H50V40H55V35Z" fill="#F4D5B8"/>
    <path d="M55 30H50V35H55V30Z" fill="#F4D5B8"/>
    <path d="M50 45H45V50H50V45Z" fill="#F4D5B8"/>
    <path d="M50 40H45V45H50V40Z" fill="#F4D5B8"/>
    <path d="M50 35H45V40H50V35Z" fill="#F4D5B8"/>
    <path d="M50 30H45V35H50V30Z" fill="#F4D5B8"/>
    <path d="M50 25H45V30H50V25Z" fill="#F4D5B8"/>
    <path d="M50 20H45V25H50V20Z" fill="#F4D5B8"/>
    <path d="M50 15H45V20H50V15Z" fill="#F4D5B8"/>
    <path d="M45 45H40V50H45V45Z" fill="#F4D5B8"/>
    <path d="M45 40H40V45H45V40Z" fill="#F4D5B8"/>
    <path d="M45 35H40V40H45V35Z" fill="#F4D5B8"/>
    <path d="M45 30H40V35H45V30Z" fill="#F4D5B8"/>
    <path d="M45 25H40V30H45V25Z" fill="#F4D5B8"/>
    <path d="M45 20H40V25H45V20Z" fill="#F4D5B8"/>
    <path d="M45 15H40V20H45V15Z" fill="#F4D5B8"/>
    <path d="M45 10H40V15H45V10Z" fill="#F4D5B8"/>
    <path d="M40 45H35V50H40V45Z" fill="#F4D5B8"/>
    <path d="M40 40H35V45H40V40Z" fill="#F4D5B8"/>
    <path d="M40 35H35V40H40V35Z" fill="#F4D5B8"/>
    <path d="M40 30H35V35H40V30Z" fill="#F4D5B8"/>
    <path d="M40 25H35V30H40V25Z" fill="#F4D5B8"/>
    <path d="M40 20H35V25H40V20Z" fill="#F4D5B8"/>
    <path d="M40 15H35V20H40V15Z" fill="#F4D5B8"/>
    <path d="M40 10H35V15H40V10Z" fill="#F4D5B8"/>
    <path d="M35 45H30V50H35V45Z" fill="#F4D5B8"/>
    <path d="M35 40H30V45H35V40Z" fill="#F4D5B8"/>
    <path d="M35 35H30V40H35V35Z" fill="#F4D5B8"/>
    <path d="M35 30H30V35H35V30Z" fill="#F4D5B8"/>
    <path d="M35 25H30V30H35V25Z" fill="#F4D5B8"/>
    <path d="M35 20H30V25H35V20Z" fill="#F4D5B8"/>
    <path d="M35 15H30V20H35V15Z" fill="#F4D5B8"/>
    <path d="M35 10H30V15H35V10Z" fill="#F4D5B8"/>
    <path d="M30 45H25V50H30V45Z" fill="#F4D5B8"/>
    <path d="M30 40H25V45H30V40Z" fill="#F4D5B8"/>
    <path d="M30 35H25V40H30V35Z" fill="#F4D5B8"/>
    <path d="M30 30H25V35H30V30Z" fill="#F4D5B8"/>
    <path d="M30 25H25V30H30V25Z" fill="#F4D5B8"/>
    <path d="M30 20H25V25H30V20Z" fill="#F4D5B8"/>
    <path d="M30 15H25V20H30V15Z" fill="#F4D5B8"/>
    <path d="M30 10H25V15H30V10Z" fill="#F4D5B8"/>
    <path d="M25 45H20V50H25V45Z" fill="#F4D5B8"/>
    <path d="M25 40H20V45H25V40Z" fill="#F4D5B8"/>
    <path d="M25 35H20V40H25V35Z" fill="#F4D5B8"/>
    <path d="M25 30H20V35H25V30Z" fill="#F4D5B8"/>
    <path d="M25 25H20V30H25V25Z" fill="#F4D5B8"/>
    <path d="M25 20H20V25H25V20Z" fill="#F4D5B8"/>
    <path d="M25 15H20V20H25V15Z" fill="#F4D5B8"/>
    <path d="M25 10H20V15H25V10Z" fill="#F4D5B8"/>
    <path d="M20 45H15V50H20V45Z" fill="#F4D5B8"/>
    <path d="M20 40H15V45H20V40Z" fill="#F4D5B8"/>
    <path d="M20 35H15V40H20V35Z" fill="#F4D5B8"/>
    <path d="M20 30H15V35H20V30Z" fill="#F4D5B8"/>
    <path d="M20 25H15V30H20V25Z" fill="#F4D5B8"/>
    <path d="M20 20H15V25H20V20Z" fill="#F4D5B8"/>
    <path d="M20 15H15V20H20V15Z" fill="#F4D5B8"/>
    <path d="M20 10H15V15H20V10Z" fill="#F4D5B8"/>
    <path d="M15 40H10V45H15V40Z" fill="#F4D5B8"/>
    <path d="M15 35H10V40H15V35Z" fill="#F4D5B8"/>
    <path d="M15 30H10V35H15V30Z" fill="#F4D5B8"/>
    <path d="M15 25H10V30H15V25Z" fill="#F4D5B8"/>
    <path d="M15 20H10V25H15V20Z" fill="#F4D5B8"/>
    <path d="M15 15H10V20H15V15Z" fill="#F4D5B8"/>
    <path d="M60 15H55V20H60V15Z" fill="#3A2616"/>
    <path d="M55 15H50V20H55V15Z" fill="#3A2616"/>
    <path d="M55 10H50V15H55V10Z" fill="#3A2616"/>
    <path d="M55 5H50V10H55V5Z" fill="#3A2616"/>
    <path d="M50 15H45V20H50V15Z" fill="#3A2616"/>
    <path d="M50 10H45V15H50V10Z" fill="#3A2616"/>
    <path d="M50 5H45V10H50V5Z" fill="#3A2616"/>
    <path d="M45 30H40V35H45V30Z" fill="#353433"/>
    <path d="M45 25H40V30H45V25Z" fill="#353433"/>
    <path d="M45 15H40V20H45V15Z" fill="#3A2616"/>
    <path d="M45 10H40V15H45V10Z" fill="#3A2616"/>
    <path d="M45 5H40V10H45V5Z" fill="#3A2616"/>
    <path d="M40 35H35V40H40V35Z" fill="white"/>
    <path d="M40 10H35V15H40V10Z" fill="#3A2616"/>
    <path d="M40 5H35V10H40V5Z" fill="#3A2616"/>
    <path d="M35 35H30V40H35V35Z" fill="white"/>
    <path d="M35 10H30V15H35V10Z" fill="#3A2616"/>
    <path d="M35 5H30V10H35V5Z" fill="#3A2616"/>
    <path d="M30 35H25V40H30V35Z" fill="white"/>
    <path d="M30 15H25V20H30V15Z" fill="#3A2616"/>
    <path d="M30 10H25V15H30V10Z" fill="#3A2616"/>
    <path d="M30 5H25V10H30V5Z" fill="#3A2616"/>
    <path d="M25 30H20V35H25V30Z" fill="#353433"/>
    <path d="M25 25H20V30H25V25Z" fill="#353433"/>
    <path d="M25 15H20V20H25V15Z" fill="#3A2616"/>
    <path d="M25 10H20V15H25V10Z" fill="#3A2616"/>
    <path d="M25 5H20V10H25V5Z" fill="#3A2616"/>
    <path d="M20 15H15V20H20V15Z" fill="#3A2616"/>
    <path d="M20 10H15V15H20V10Z" fill="#3A2616"/>
    <path d="M20 5H15V10H20V5Z" fill="#3A2616"/>
    <path d="M15 35H10V40H15V35Z" fill="#3A2616"/>
    <path d="M15 25H10V30H15V25Z" fill="#3A2616"/>
    <path d="M15 20H10V25H15V20Z" fill="#3A2616"/>
    <path d="M15 15H10V20H15V15Z" fill="#3A2616"/>
    <path d="M15 10H10V15H15V10Z" fill="#3A2616"/>
    <path d="M70 40H65V45H70V40Z" fill="#F4D5B8"/>
    <path d="M70 35H65V40H70V35Z" fill="#F4D5B8"/>
    <path d="M65 40H60V45H65V40Z" fill="#F4D5B8"/>
    <path d="M65 35H60V40H65V35Z" fill="#F4D5B8"/>
    <path d="M60 40H55V45H60V40Z" fill="#E51727"/>
    <path d="M60 35H55V40H60V35Z" fill="#567CDB"/>
    <path d="M60 30H55V35H60V30Z" fill="#567CDB"/>
    <path d="M60 25H55V30H60V25Z" fill="#567CDB"/>
    <path d="M60 20H55V25H60V20Z" fill="#567CDB"/>
    <path d="M55 45H50V50H55V45Z" fill="#E51727"/>
    <path d="M55 25H50V30H55V25Z" fill="#567CDB"/>
    <path d="M55 20H50V25H55V20Z" fill="#567CDB"/>
    <path d="M50 50H45V55H50V50Z" fill="#E51727"/>
    <path d="M45 55H40V60H45V55Z" fill="#E51727"/>
    <path d="M45 50H40V55H45V50Z" fill="#E51727"/>
    <path d="M45 0H40V5H45V0Z" fill="#567CDB"/>
    <path d="M40 80H35V85H40V80Z" fill="#49545B"/>
    <path d="M40 75H35V80H40V75Z" fill="#49545B"/>
    <path d="M40 70H35V75H40V70Z" fill="#E51727"/>
    <path d="M40 65H35V70H40V65Z" fill="#E51727"/>
    <path d="M40 60H35V65H40V60Z" fill="#E51727"/>
    <path d="M40 55H35V60H40V55Z" fill="#E51727"/>
    <path d="M40 50H35V55H40V50Z" fill="#E51727"/>
    <path d="M40 0H35V5H40V0Z" fill="#567CDB"/>
    <path d="M35 75H30V80H35V75Z" fill="#49545B"/>
    <path d="M35 70H30V75H35V70Z" fill="#E51727"/>
    <path d="M35 65H30V70H35V65Z" fill="#E51727"/>
    <path d="M35 60H30V65H35V60Z" fill="#E51727"/>
    <path d="M35 55H30V60H35V55Z" fill="#E51727"/>
    <path d="M35 50H30V55H35V50Z" fill="#E51727"/>
    <path d="M35 0H30V5H35V0Z" fill="#567CDB"/>
    <path d="M30 75H25V80H30V75Z" fill="#49545B"/>
    <path d="M30 70H25V75H30V70Z" fill="#E51727"/>
    <path d="M30 65H25V70H30V65Z" fill="#E51727"/>
    <path d="M30 60H25V65H30V60Z" fill="#E51727"/>
    <path d="M30 55H25V60H30V55Z" fill="#E51727"/>
    <path d="M30 50H25V55H30V50Z" fill="#E51727"/>
    <path d="M30 0H25V5H30V0Z" fill="#567CDB"/>
    <path d="M25 85H20V90H25V85Z" fill="#49545B"/>
    <path d="M25 80H20V85H25V80Z" fill="#49545B"/>
    <path d="M25 75H20V80H25V75Z" fill="#49545B"/>
    <path d="M25 70H20V75H25V70Z" fill="#E51727"/>
    <path d="M25 65H20V70H25V65Z" fill="#E51727"/>
    <path d="M25 60H20V65H25V60Z" fill="#E51727"/>
    <path d="M25 55H20V60H25V55Z" fill="#E51727"/>
    <path d="M25 50H20V55H25V50Z" fill="#E51727"/>
    <path d="M25 0H20V5H25V0Z" fill="#567CDB"/>
    <path d="M20 0H15V5H20V0Z" fill="#567CDB"/>
    <path d="M15 35H10V40H15V35Z" fill="#567CDB"/>
    <path d="M15 30H10V35H15V30Z" fill="#567CDB"/>
    <path d="M15 25H10V30H15V25Z" fill="#567CDB"/>
    <path d="M15 20H10V25H15V20Z" fill="#567CDB"/>
    <path d="M15 15H10V20H15V15Z" fill="#567CDB"/>
    <path d="M15 10H10V15H15V10Z" fill="#567CDB"/>
    <path d="M15 5H10V10H15V5Z" fill="#567CDB"/>
    <path d="M10 35H5V40H10V35Z" fill="#567CDB"/>
    <path d="M10 30H5V35H10V30Z" fill="#567CDB"/>
    <path d="M10 25H5V30H10V25Z" fill="#567CDB"/>
    <path d="M10 20H5V25H10V20Z" fill="#567CDB"/>
    <path d="M5 65H0V70H5V65Z" fill="#F4D5B8"/>
    <path d="M5 60H0V65H5V60Z" fill="#F4D5B8"/>
    <path d="M25 55H20V60H25V55Z" fill="#EA243C"/>
    <path d="M25 50H20V55H25V50Z" fill="#EA243C"/>
    <path d="M20 60H15V65H20V60Z" fill="#EA243C"/>
    <path d="M20 55H15V60H20V55Z" fill="#EA243C"/>
    <path d="M20 50H15V55H20V50Z" fill="#EA243C"/>
    <path d="M15 65H10V70H15V65Z" fill="#EA243C"/>
    <path d="M15 60H10V65H15V60Z" fill="#EA243C"/>
    <path d="M15 55H10V60H15V55Z" fill="#EA243C"/>
    <path d="M10 65H5V70H10V65Z" fill="#F4D5B8"/>
    <path d="M10 60H5V65H10V60Z" fill="#F4D5B8"/>
    <path d="M60 15H55V20H60V15Z" fill="#493223"/>
    <path d="M55 15H50V20H55V15Z" fill="#493223"/>
    <path d="M55 10H50V15H55V10Z" fill="#493223"/>
    <path d="M55 5H50V10H55V5Z" fill="#493223"/>
    <path d="M50 15H45V20H50V15Z" fill="#493223"/>
    <path d="M50 10H45V15H50V10Z" fill="#493223"/>
    <path d="M50 5H45V10H50V5Z" fill="#493223"/>
    <path d="M45 95H40V100H45V95Z" fill="#9E6C43"/>
    <path d="M45 15H40V20H45V15Z" fill="#3F2A1B"/>
    <path d="M45 10H40V15H45V10Z" fill="#493223"/>
    <path d="M45 5H40V10H45V5Z" fill="#493223"/>
    <path d="M40 95H35V100H40V95Z" fill="#9E6C43"/>
    <path d="M40 90H35V95H40V90Z" fill="#9E6C43"/>
    <path d="M40 85H35V90H40V85Z" fill="#6A7277"/>
    <path d="M40 80H35V85H40V80Z" fill="#6A7277"/>
    <path d="M40 75H35V80H40V75Z" fill="#6A7277"/>
    <path d="M40 10H35V15H40V10Z" fill="#493223"/>
    <path d="M40 5H35V10H40V5Z" fill="#493223"/>
    <path d="M35 75H30V80H35V75Z" fill="#6A7277"/>
    <path d="M35 5H30V10H35V5Z" fill="#493223"/>
    <path d="M30 75H25V80H30V75Z" fill="#6A7277"/>
    <path d="M30 5H25V10H30V5Z" fill="#493223"/>
    <path d="M25 70H20V75H25V70Z" fill="#DD172F"/>
    <path d="M25 65H20V70H25V65Z" fill="#DD172F"/>
    <path d="M25 60H20V65H25V60Z" fill="#DD172F"/>
    <path d="M20 85H15V90H20V85Z" fill="#9E6C43"/>
    <path d="M20 45H15V50H20V45Z" fill="#DDBB9F"/>
    <path d="M15 90H10V95H15V90Z" fill="#9E6C43"/>
    <path d="M15 85H10V90H15V85Z" fill="#9E6C43"/>
    <path d="M15 40H10V45H15V40Z" fill="#DDBB9F"/>
    <path d="M10 60H5V65H10V60Z" fill="#DDBB9F"/>
    <path d="M5 60H0V65H5V60Z" fill="#DDBB9F"/>
    </svg>`;
  }

  girl1() {
    return `<svg width="90" height="150" viewBox="0 0 90 150" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72 138H66V144H72V138Z" fill="#45A6DB"/>
    <path d="M42 138H36V144H42V138Z" fill="#45A6DB"/>
    <path d="M42 144H36V150H42V144Z" fill="#45A6DB"/>
    <path d="M36 144H30V150H36V144Z" fill="#45A6DB"/>
    <path d="M72 72H66V78H72V72Z" fill="#F4D5B8"/>
    <path d="M72 66H66V72H72V66Z" fill="#F4D5B8"/>
    <path d="M72 60H66V66H72V60Z" fill="#F4D5B8"/>
    <path d="M72 54H66V60H72V54Z" fill="#F4D5B8"/>
    <path d="M72 48H66V54H72V48Z" fill="#F4D5B8"/>
    <path d="M72 42H66V48H72V42Z" fill="#F4D5B8"/>
    <path d="M66 78H60V84H66V78Z" fill="#F4D5B8"/>
    <path d="M66 72H60V78H66V72Z" fill="#F4D5B8"/>
    <path d="M66 66H60V72H66V66Z" fill="#F4D5B8"/>
    <path d="M66 60H60V66H66V60Z" fill="#F4D5B8"/>
    <path d="M66 54H60V60H66V54Z" fill="#F4D5B8"/>
    <path d="M66 48H60V54H66V48Z" fill="#F4D5B8"/>
    <path d="M66 42H60V48H66V42Z" fill="#F4D5B8"/>
    <path d="M66 36H60V42H66V36Z" fill="#F4D5B8"/>
    <path d="M60 78H54V84H60V78Z" fill="#F4D5B8"/>
    <path d="M60 72H54V78H60V72Z" fill="#F4D5B8"/>
    <path d="M60 66H54V72H60V66Z" fill="#F4D5B8"/>
    <path d="M60 60H54V66H60V60Z" fill="#F4D5B8"/>
    <path d="M60 54H54V60H60V54Z" fill="#F4D5B8"/>
    <path d="M60 48H54V54H60V48Z" fill="#F4D5B8"/>
    <path d="M60 42H54V48H60V42Z" fill="#F4D5B8"/>
    <path d="M60 36H54V42H60V36Z" fill="#F4D5B8"/>
    <path d="M54 78H48V84H54V78Z" fill="#F4D5B8"/>
    <path d="M54 72H48V78H54V72Z" fill="#F4D5B8"/>
    <path d="M54 66H48V72H54V66Z" fill="#F4D5B8"/>
    <path d="M54 60H48V66H54V60Z" fill="#F4D5B8"/>
    <path d="M54 54H48V60H54V54Z" fill="#F4D5B8"/>
    <path d="M54 48H48V54H54V48Z" fill="#F4D5B8"/>
    <path d="M54 42H48V48H54V42Z" fill="#F4D5B8"/>
    <path d="M54 36H48V42H54V36Z" fill="#F4D5B8"/>
    <path d="M48 78H42V84H48V78Z" fill="#F4D5B8"/>
    <path d="M48 72H42V78H48V72Z" fill="#F4D5B8"/>
    <path d="M48 66H42V72H48V66Z" fill="#F4D5B8"/>
    <path d="M48 60H42V66H48V60Z" fill="#F4D5B8"/>
    <path d="M48 54H42V60H48V54Z" fill="#F4D5B8"/>
    <path d="M48 48H42V54H48V48Z" fill="#F4D5B8"/>
    <path d="M48 42H42V48H48V42Z" fill="#F4D5B8"/>
    <path d="M48 36H42V42H48V36Z" fill="#F4D5B8"/>
    <path d="M42 78H36V84H42V78Z" fill="#F4D5B8"/>
    <path d="M42 72H36V78H42V72Z" fill="#F4D5B8"/>
    <path d="M42 66H36V72H42V66Z" fill="#F4D5B8"/>
    <path d="M42 60H36V66H42V60Z" fill="#F4D5B8"/>
    <path d="M42 54H36V60H42V54Z" fill="#F4D5B8"/>
    <path d="M42 48H36V54H42V48Z" fill="#F4D5B8"/>
    <path d="M42 42H36V48H42V42Z" fill="#F4D5B8"/>
    <path d="M42 36H36V42H42V36Z" fill="#F4D5B8"/>
    <path d="M36 78H30V84H36V78Z" fill="#F4D5B8"/>
    <path d="M36 72H30V78H36V72Z" fill="#F4D5B8"/>
    <path d="M36 66H30V72H36V66Z" fill="#F4D5B8"/>
    <path d="M36 60H30V66H36V60Z" fill="#F4D5B8"/>
    <path d="M36 54H30V60H36V54Z" fill="#F4D5B8"/>
    <path d="M36 48H30V54H36V48Z" fill="#F4D5B8"/>
    <path d="M36 42H30V48H36V42Z" fill="#F4D5B8"/>
    <path d="M36 36H30V42H36V36Z" fill="#F4D5B8"/>
    <path d="M30 78H24V84H30V78Z" fill="#F4D5B8"/>
    <path d="M30 72H24V78H30V72Z" fill="#F4D5B8"/>
    <path d="M30 66H24V72H30V66Z" fill="#F4D5B8"/>
    <path d="M30 60H24V66H30V60Z" fill="#F4D5B8"/>
    <path d="M30 54H24V60H30V54Z" fill="#F4D5B8"/>
    <path d="M30 48H24V54H30V48Z" fill="#F4D5B8"/>
    <path d="M30 42H24V48H30V42Z" fill="#F4D5B8"/>
    <path d="M24 72H18V78H24V72Z" fill="#F4D5B8"/>
    <path d="M24 66H18V72H24V66Z" fill="#F4D5B8"/>
    <path d="M24 60H18V66H24V60Z" fill="#F4D5B8"/>
    <path d="M90 66H84V72H90V66Z" fill="#F4D5B8"/>
    <path d="M90 60H84V66H90V60Z" fill="#F4D5B8"/>
    <path d="M84 84H78V90H84V84Z" fill="#E51727"/>
    <path d="M84 78H78V84H84V78Z" fill="#E51727"/>
    <path d="M84 72H78V78H84V72Z" fill="#E51727"/>
    <path d="M84 66H78V72H84V66Z" fill="#F4D5B8"/>
    <path d="M84 60H78V66H84V60Z" fill="#F4D5B8"/>
    <path d="M78 90H72V96H78V90Z" fill="#E51727"/>
    <path d="M78 84H72V90H78V84Z" fill="#E51727"/>
    <path d="M78 78H72V84H78V78Z" fill="#E51727"/>
    <path d="M78 72H72V78H78V72Z" fill="#E51727"/>
    <path d="M72 138H66V144H72V138Z" fill="#49545B"/>
    <path d="M72 132H66V138H72V132Z" fill="#49545B"/>
    <path d="M72 90H66V96H72V90Z" fill="#E51727"/>
    <path d="M72 84H66V90H72V84Z" fill="#E51727"/>
    <path d="M66 132H60V138H66V132Z" fill="#49545B"/>
    <path d="M66 90H60V96H66V90Z" fill="#E51727"/>
    <path d="M66 84H60V90H66V84Z" fill="#E51727"/>
    <path d="M60 132H54V138H60V132Z" fill="#49545B"/>
    <path d="M60 126H54V132H60V126Z" fill="#49545B"/>
    <path d="M60 120H54V126H60V120Z" fill="#49545B"/>
    <path d="M60 114H54V120H60V114Z" fill="#49545B"/>
    <path d="M60 108H54V114H60V108Z" fill="#E51727"/>
    <path d="M60 102H54V108H60V102Z" fill="#FFD2D7"/>
    <path d="M60 96H54V102H60V96Z" fill="#E51727"/>
    <path d="M60 90H54V96H60V90Z" fill="#FFD2D7"/>
    <path d="M60 84H54V90H60V84Z" fill="#E51727"/>
    <path d="M60 60H54V66H60V60Z" fill="#353433"/>
    <path d="M60 54H54V60H60V54Z" fill="#353433"/>
    <path d="M54 114H48V120H54V114Z" fill="#49545B"/>
    <path d="M54 108H48V114H54V108Z" fill="#E51727"/>
    <path d="M54 102H48V108H54V102Z" fill="#FFD2D7"/>
    <path d="M54 96H48V102H54V96Z" fill="#E51727"/>
    <path d="M54 90H48V96H54V90Z" fill="#FFD2D7"/>
    <path d="M54 84H48V90H54V84Z" fill="#E51727"/>
    <path d="M54 66H48V72H54V66Z" fill="#F7F5F0"/>
    <path d="M48 114H42V120H48V114Z" fill="#49545B"/>
    <path d="M48 108H42V114H48V108Z" fill="#E51727"/>
    <path d="M48 102H42V108H48V102Z" fill="#FFD2D7"/>
    <path d="M48 96H42V102H48V96Z" fill="#E51727"/>
    <path d="M48 90H42V96H48V90Z" fill="#FFD2D7"/>
    <path d="M48 84H42V90H48V84Z" fill="#E51727"/>
    <path d="M48 66H42V72H48V66Z" fill="#F7F5F0"/>
    <path d="M42 144H36V150H42V144Z" fill="#49545B"/>
    <path d="M42 138H36V144H42V138Z" fill="#49545B"/>
    <path d="M42 132H36V138H42V132Z" fill="#49545B"/>
    <path d="M42 126H36V132H42V126Z" fill="#49545B"/>
    <path d="M42 120H36V126H42V120Z" fill="#49545B"/>
    <path d="M42 114H36V120H42V114Z" fill="#49545B"/>
    <path d="M42 108H36V114H42V108Z" fill="#E51727"/>
    <path d="M42 102H36V108H42V102Z" fill="#FFD2D7"/>
    <path d="M42 96H36V102H42V96Z" fill="#E51727"/>
    <path d="M42 90H36V96H42V90Z" fill="#FFD2D7"/>
    <path d="M42 84H36V90H42V84Z" fill="#E51727"/>
    <path d="M42 66H36V72H42V66Z" fill="#F7F5F0"/>
    <path d="M36 144H30V150H36V144Z" fill="#49545B"/>
    <path d="M36 90H30V96H36V90Z" fill="#E51727"/>
    <path d="M36 84H30V90H36V84Z" fill="#E51727"/>
    <path d="M36 60H30V66H36V60Z" fill="#353433"/>
    <path d="M36 54H30V60H36V54Z" fill="#353433"/>
    <path d="M30 90H24V96H30V90Z" fill="#E51727"/>
    <path d="M30 84H24V90H30V84Z" fill="#E51727"/>
    <path d="M24 90H18V96H24V90Z" fill="#E51727"/>
    <path d="M24 84H18V90H24V84Z" fill="#E51727"/>
    <path d="M18 90H12V96H18V90Z" fill="#E51727"/>
    <path d="M18 84H12V90H18V84Z" fill="#E51727"/>
    <path d="M12 90H6V96H12V90Z" fill="#F4D5B8"/>
    <path d="M12 84H6V90H12V84Z" fill="#F4D5B8"/>
    <path d="M6 90H0V96H6V90Z" fill="#F4D5B8"/>
    <path d="M6 84H0V90H6V84Z" fill="#F4D5B8"/>
    <path d="M90 6H84V12H90V6Z" fill="#F7F5F0"/>
    <path d="M90 0H84V6H90V0Z" fill="#F7F5F0"/>
    <path d="M84 6H78V12H84V6Z" fill="#F7F5F0"/>
    <path d="M84 0H78V6H84V0Z" fill="#F42F47"/>
    <path d="M78 18H72V24H78V18Z" fill="#BC0020"/>
    <path d="M78 12H72V18H78V12Z" fill="#BC0020"/>
    <path d="M78 6H72V12H78V6Z" fill="#E51727"/>
    <path d="M78 0H72V6H78V0Z" fill="#F42F47"/>
    <path d="M72 90H66V96H72V90Z" fill="#E56F29"/>
    <path d="M72 84H66V90H72V84Z" fill="#E56F29"/>
    <path d="M72 78H66V84H72V78Z" fill="#E56F29"/>
    <path d="M72 72H66V78H72V72Z" fill="#E56F29"/>
    <path d="M72 66H66V72H72V66Z" fill="#E56F29"/>
    <path d="M72 60H66V66H72V60Z" fill="#E56F29"/>
    <path d="M72 54H66V60H72V54Z" fill="#E56F29"/>
    <path d="M72 48H66V54H72V48Z" fill="#E56F29"/>
    <path d="M72 42H66V48H72V42Z" fill="#E56F29"/>
    <path d="M72 36H66V42H72V36Z" fill="#E56F29"/>
    <path d="M72 30H66V36H72V30Z" fill="#DDC5C6"/>
    <path d="M72 24H66V30H72V24Z" fill="#DDC5C6"/>
    <path d="M72 18H66V24H72V18Z" fill="#BC0020"/>
    <path d="M72 12H66V18H72V12Z" fill="#E51727"/>
    <path d="M72 6H66V12H72V6Z" fill="#E51727"/>
    <path d="M72 0H66V6H72V0Z" fill="#F42F47"/>
    <path d="M66 96H60V102H66V96Z" fill="#E56F29"/>
    <path d="M66 42H60V48H66V42Z" fill="#E56F29"/>
    <path d="M66 36H60V42H66V36Z" fill="#E56F29"/>
    <path d="M66 30H60V36H66V30Z" fill="#E56F29"/>
    <path d="M66 24H60V30H66V24Z" fill="#DDC5C6"/>
    <path d="M66 18H60V24H66V18Z" fill="#DDC5C6"/>
    <path d="M66 12H60V18H66V12Z" fill="#E51727"/>
    <path d="M66 6H60V12H66V6Z" fill="#E51727"/>
    <path d="M66 0H60V6H66V0Z" fill="#F42F47"/>
    <path d="M60 36H54V42H60V36Z" fill="#E56F29"/>
    <path d="M60 30H54V36H60V30Z" fill="#E56F29"/>
    <path d="M60 24H54V30H60V24Z" fill="#DDC5C6"/>
    <path d="M60 18H54V24H60V18Z" fill="#F7F5F0"/>
    <path d="M60 12H54V18H60V12Z" fill="#E51727"/>
    <path d="M60 6H54V12H60V6Z" fill="#E51727"/>
    <path d="M60 0H54V6H60V0Z" fill="#F42F47"/>
    <path d="M54 36H48V42H54V36Z" fill="#E56F29"/>
    <path d="M54 30H48V36H54V30Z" fill="#E56F29"/>
    <path d="M54 24H48V30H54V24Z" fill="#F7F5F0"/>
    <path d="M54 18H48V24H54V18Z" fill="#F7F5F0"/>
    <path d="M54 12H48V18H54V12Z" fill="#E51727"/>
    <path d="M54 6H48V12H54V6Z" fill="#F42F47"/>
    <path d="M48 36H42V42H48V36Z" fill="#E56F29"/>
    <path d="M48 30H42V36H48V30Z" fill="#E56F29"/>
    <path d="M48 24H42V30H48V24Z" fill="#F7F5F0"/>
    <path d="M48 18H42V24H48V18Z" fill="#F7F5F0"/>
    <path d="M48 12H42V18H48V12Z" fill="#F42F47"/>
    <path d="M48 6H42V12H48V6Z" fill="#F42F47"/>
    <path d="M42 36H36V42H42V36Z" fill="#E56F29"/>
    <path d="M42 30H36V36H42V30Z" fill="#E56F29"/>
    <path d="M42 24H36V30H42V24Z" fill="#F7F5F0"/>
    <path d="M42 18H36V24H42V18Z" fill="#F7F5F0"/>
    <path d="M42 12H36V18H42V12Z" fill="#F42F47"/>
    <path d="M36 36H30V42H36V36Z" fill="#E56F29"/>
    <path d="M36 30H30V36H36V30Z" fill="#E56F29"/>
    <path d="M36 24H30V30H36V24Z" fill="#F7F5F0"/>
    <path d="M36 18H30V24H36V18Z" fill="#F7F5F0"/>
    <path d="M30 96H24V102H30V96Z" fill="#E56F29"/>
    <path d="M30 42H24V48H30V42Z" fill="#E56F29"/>
    <path d="M30 36H24V42H30V36Z" fill="#E56F29"/>
    <path d="M30 30H24V36H30V30Z" fill="#E56F29"/>
    <path d="M30 24H24V30H30V24Z" fill="#F7F5F0"/>
    <path d="M24 90H18V96H24V90Z" fill="#E56F29"/>
    <path d="M24 84H18V90H24V84Z" fill="#E56F29"/>
    <path d="M24 78H18V84H24V78Z" fill="#E56F29"/>
    <path d="M24 72H18V78H24V72Z" fill="#E56F29"/>
    <path d="M24 66H18V72H24V66Z" fill="#E56F29"/>
    <path d="M24 60H18V66H24V60Z" fill="#E56F29"/>
    <path d="M24 54H18V60H24V54Z" fill="#E56F29"/>
    <path d="M24 48H18V54H24V48Z" fill="#E56F29"/>
    <path d="M24 42H18V48H24V42Z" fill="#E56F29"/>
    <path d="M24 36H18V42H24V36Z" fill="#E56F29"/>
    <path d="M84 84H78V90H84V84Z" fill="#DB122A"/>
    <path d="M84 78H78V84H84V78Z" fill="#DB122A"/>
    <path d="M84 72H78V78H84V72Z" fill="#DB122A"/>
    <path d="M78 90H72V96H78V90Z" fill="#DB122A"/>
    <path d="M72 138H66V144H72V138Z" fill="#9E6C43"/>
    <path d="M72 132H66V138H72V132Z" fill="#9E6C43"/>
    <path d="M66 132H60V138H66V132Z" fill="#9E6C43"/>
    <path d="M66 90H60V96H66V90Z" fill="#DB122A"/>
    <path d="M66 78H60V84H66V78Z" fill="#E8C4A6"/>
    <path d="M66 72H60V78H66V72Z" fill="#E8C4A6"/>
    <path d="M66 66H60V72H66V66Z" fill="#E8C4A6"/>
    <path d="M66 60H60V66H66V60Z" fill="#E8C4A6"/>
    <path d="M66 54H60V60H66V54Z" fill="#E8C4A6"/>
    <path d="M66 48H60V54H66V48Z" fill="#E8C4A6"/>
    <path d="M60 132H54V138H60V132Z" fill="#9E6C43"/>
    <path d="M60 84H54V90H60V84Z" fill="#DB122A"/>
    <path d="M60 42H54V48H60V42Z" fill="#E8C4A6"/>
    <path d="M48 114H42V120H48V114Z" fill="#6A7277"/>
    <path d="M48 102H42V108H48V102Z" fill="#FFE6EA"/>
    <path d="M48 30H42V36H48V30Z" fill="#EF7A3F"/>
    <path d="M42 144H36V150H42V144Z" fill="#9E6C43"/>
    <path d="M42 138H36V144H42V138Z" fill="#9E6C43"/>
    <path d="M42 132H36V138H42V132Z" fill="#9E6C43"/>
    <path d="M42 126H36V132H42V126Z" fill="#6A7277"/>
    <path d="M42 120H36V126H42V120Z" fill="#6A7277"/>
    <path d="M42 114H36V120H42V114Z" fill="#6A7277"/>
    <path d="M42 108H36V114H42V108Z" fill="#F43149"/>
    <path d="M42 102H36V108H42V102Z" fill="#FFE6EA"/>
    <path d="M42 96H36V102H42V96Z" fill="#F43149"/>
    <path d="M42 90H36V96H42V90Z" fill="#FFE6EA"/>
    <path d="M42 84H36V90H42V84Z" fill="#F43149"/>
    <path d="M42 30H36V36H42V30Z" fill="#EF7A3F"/>
    <path d="M36 144H30V150H36V144Z" fill="#9E6C43"/>
    <path d="M36 90H30V96H36V90Z" fill="#DB122A"/>
    <path d="M36 30H30V36H36V30Z" fill="#EF7A3F"/>
    <path d="M30 96H24V102H30V96Z" fill="#EF7A3F"/>
    <path d="M30 90H24V96H30V90Z" fill="#DB122A"/>
    <path d="M30 36H24V42H30V36Z" fill="#EF7A3F"/>
    <path d="M30 30H24V36H30V30Z" fill="#EF7A3F"/>
    <path d="M24 90H18V96H24V90Z" fill="#EF7A3F"/>
    <path d="M24 84H18V90H24V84Z" fill="#EF7A3F"/>
    <path d="M24 78H18V84H24V78Z" fill="#EF7A3F"/>
    <path d="M24 72H18V78H24V72Z" fill="#EF7A3F"/>
    <path d="M24 66H18V72H24V66Z" fill="#EF7A3F"/>
    <path d="M24 60H18V66H24V60Z" fill="#EF7A3F"/>
    <path d="M24 54H18V60H24V54Z" fill="#EF7A3F"/>
    <path d="M24 48H18V54H24V48Z" fill="#EF7A3F"/>
    <path d="M24 42H18V48H24V42Z" fill="#EF7A3F"/>
    <path d="M24 36H18V42H24V36Z" fill="#EF7A3F"/>
    <path d="M18 90H12V96H18V90Z" fill="#DB122A"/>
    </svg>`;
  }

  girl2() {
    return `<svg width="70" height="105" viewBox="0 0 70 105" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 15H45V20H50V15Z" fill="#F4D5B8"/>
    <path d="M50 20H45V25H50V20Z" fill="#F4D5B8"/>
    <path d="M50 25H45V30H50V25Z" fill="#F4D5B8"/>
    <path d="M50 30H45V35H50V30Z" fill="#F4D5B8"/>
    <path d="M50 35H45V40H50V35Z" fill="#F4D5B8"/>
    <path d="M50 40H45V45H50V40Z" fill="#F4D5B8"/>
    <path d="M35 15H30V20H35V15Z" fill="#F4D5B8"/>
    <path d="M35 20H30V25H35V20Z" fill="#F4D5B8"/>
    <path d="M35 25H30V30H35V25Z" fill="#F4D5B8"/>
    <path d="M35 30H30V35H35V30Z" fill="#F4D5B8"/>
    <path d="M35 35H30V40H35V35Z" fill="#F4D5B8"/>
    <path d="M20 30H15V35H20V30Z" fill="#F4D5B8"/>
    <path d="M20 35H15V40H20V35Z" fill="#F4D5B8"/>
    <path d="M20 40H15V45H20V40Z" fill="#F4D5B8"/>
    <path d="M25 15H20V20H25V15Z" fill="#F4D5B8"/>
    <path d="M25 20H20V25H25V20Z" fill="#F4D5B8"/>
    <path d="M25 25H20V30H25V25Z" fill="#F4D5B8"/>
    <path d="M25 30H20V35H25V30Z" fill="#F4D5B8"/>
    <path d="M25 35H20V40H25V35Z" fill="#F4D5B8"/>
    <path d="M25 40H20V45H25V40Z" fill="#F4D5B8"/>
    <path d="M30 15H25V20H30V15Z" fill="#F4D5B8"/>
    <path d="M30 20H25V25H30V20Z" fill="#F4D5B8"/>
    <path d="M30 25H25V30H30V25Z" fill="#F4D5B8"/>
    <path d="M30 30H25V35H30V30Z" fill="#F4D5B8"/>
    <path d="M30 35H25V40H30V35Z" fill="#F4D5B8"/>
    <path d="M30 40H25V45H30V40Z" fill="#F4D5B8"/>
    <path d="M35 40H30V45H35V40Z" fill="#F4D5B8"/>
    <path d="M40 15H35V20H40V15Z" fill="#F4D5B8"/>
    <path d="M40 25H35V30H40V25Z" fill="#F4D5B8"/>
    <path d="M40 30H35V35H40V30Z" fill="#F4D5B8"/>
    <path d="M40 35H35V40H40V35Z" fill="#F4D5B8"/>
    <path d="M40 40H35V45H40V40Z" fill="#F4D5B8"/>
    <path d="M45 15H40V20H45V15Z" fill="#F4D5B8"/>
    <path d="M45 40H40V45H45V40Z" fill="#F4D5B8"/>
    <path d="M45 35H40V40H45V35Z" fill="#F4D5B8"/>
    <path d="M45 30H40V35H45V30Z" fill="#F4D5B8"/>
    <path d="M45 25H40V30H45V25Z" fill="#F4D5B8"/>
    <path d="M45 20H40V25H45V20Z" fill="#F4D5B8"/>
    <path d="M40 20H35V25H40V20Z" fill="#F4D5B8"/>
    <path d="M50 10H45V15H50V10Z" fill="#F4D5B8"/>
    <path d="M45 10H40V15H45V10Z" fill="#F4D5B8"/>
    <path d="M40 10H35V15H40V10Z" fill="#F4D5B8"/>
    <path d="M35 10H30V15H35V10Z" fill="#F4D5B8"/>
    <path d="M30 10H25V15H30V10Z" fill="#F4D5B8"/>
    <path d="M25 10H20V15H25V10Z" fill="#F4D5B8"/>
    <path d="M20 20H15V25H20V20Z" fill="#F4D5B8"/>
    <path d="M20 25H15V30H20V25Z" fill="#F4D5B8"/>
    <path d="M20 15H15V20H20V15Z" fill="#F4D5B8"/>
    <path d="M55 35H50V40H55V35Z" fill="#F4D5B8"/>
    <path d="M55 20H50V25H55V20Z" fill="#F4D5B8"/>
    <path d="M55 25H50V30H55V25Z" fill="#F4D5B8"/>
    <path d="M55 15H50V20H55V15Z" fill="#F4D5B8"/>
    <path d="M55 30H50V35H55V30Z" fill="#F4D5B8"/>
    <path d="M55 40H50V45H55V40Z" fill="#F4D5B8"/>
    <path d="M50 45H45V50H50V45Z" fill="#F4D5B8"/>
    <path d="M45 45H40V50H45V45Z" fill="#F4D5B8"/>
    <path d="M40 45H35V50H40V45Z" fill="#F4D5B8"/>
    <path d="M35 45H30V50H35V45Z" fill="#F4D5B8"/>
    <path d="M30 45H25V50H30V45Z" fill="#F4D5B8"/>
    <path d="M25 45H20V50H25V45Z" fill="#F4D5B8"/>
    <path d="M20 45H15V50H20V45Z" fill="#F4D5B8"/>
    <path d="M15 35H10V40H15V35Z" fill="#F4D5B8"/>
    <path d="M15 40H10V45H15V40Z" fill="#F4D5B8"/>
    <path d="M15 30H10V35H15V30Z" fill="#F4D5B8"/>
    <path d="M70 35H65V40H70V35Z" fill="#F4D5B8"/>
    <path d="M70 40H65V45H70V40Z" fill="#F4D5B8"/>
    <path d="M65 35H60V40H65V35Z" fill="#F4D5B8"/>
    <path d="M65 40H60V45H65V40Z" fill="#F4D5B8"/>
    <path d="M65 45H60V50H65V45Z" fill="#EA637A"/>
    <path d="M60 40H55V45H60V40Z" fill="#EA637A"/>
    <path d="M60 50H55V55H60V50Z" fill="#EA637A"/>
    <path d="M60 45H55V50H60V45Z" fill="#EA637A"/>
    <path d="M55 45H50V50H55V45Z" fill="#EA637A"/>
    <path d="M55 55H50V60H55V55Z" fill="#EA637A"/>
    <path d="M55 50H50V55H55V50Z" fill="#EA637A"/>
    <path d="M50 50H45V55H50V50Z" fill="#EA637A"/>
    <path d="M50 55H45V60H50V55Z" fill="#EA637A"/>
    <path d="M15 50H10V55H15V50Z" fill="#EA637A"/>
    <path d="M5 35H0V40H5V35Z" fill="#F4D5B8"/>
    <path d="M5 40H0V45H5V40Z" fill="#F4D5B8"/>
    <path d="M10 35H5V40H10V35Z" fill="#F4D5B8"/>
    <path d="M15 40H10V45H15V40Z" fill="#EA637A"/>
    <path d="M15 45H10V50H15V45Z" fill="#EA637A"/>
    <path d="M10 45H5V50H10V45Z" fill="#EA637A"/>
    <path d="M10 40H5V45H10V40Z" fill="#F4D5B8"/>
    <path d="M45 85H40V90H45V85Z" fill="#49545B"/>
    <path d="M45 80H40V85H45V80Z" fill="#49545B"/>
    <path d="M45 75H40V80H45V75Z" fill="#49545B"/>
    <path d="M45 70H40V75H45V70Z" fill="#EA637A"/>
    <path d="M45 65H40V70H45V65Z" fill="#EA637A"/>
    <path d="M45 60H40V65H45V60Z" fill="#EA637A"/>
    <path d="M45 55H40V60H45V55Z" fill="#EA637A"/>
    <path d="M45 50H40V55H45V50Z" fill="#EA637A"/>
    <path d="M45 30H40V35H45V30Z" fill="#353433"/>
    <path d="M45 25H40V30H45V25Z" fill="#353433"/>
    <path d="M40 75H35V80H40V75Z" fill="#49545B"/>
    <path d="M40 70H35V75H40V70Z" fill="#EA637A"/>
    <path d="M40 65H35V70H40V65Z" fill="#EA637A"/>
    <path d="M40 60H35V65H40V60Z" fill="#EA637A"/>
    <path d="M40 55H35V60H40V55Z" fill="#EA637A"/>
    <path d="M40 50H35V55H40V50Z" fill="#EA637A"/>
    <path d="M40 35H35V40H40V35Z" fill="#F7F5F0"/>
    <path d="M35 75H30V80H35V75Z" fill="#49545B"/>
    <path d="M35 70H30V75H35V70Z" fill="#EA637A"/>
    <path d="M35 65H30V70H35V65Z" fill="#EA637A"/>
    <path d="M35 60H30V65H35V60Z" fill="#EA637A"/>
    <path d="M35 55H30V60H35V55Z" fill="#EA637A"/>
    <path d="M35 50H30V55H35V50Z" fill="#EA637A"/>
    <path d="M35 35H30V40H35V35Z" fill="#F7F5F0"/>
    <path d="M30 85H25V90H30V85Z" fill="#49545B"/>
    <path d="M30 80H25V85H30V80Z" fill="#49545B"/>
    <path d="M30 75H25V80H30V75Z" fill="#49545B"/>
    <path d="M30 70H25V75H30V70Z" fill="#EA637A"/>
    <path d="M30 65H25V70H30V65Z" fill="#EA637A"/>
    <path d="M30 60H25V65H30V60Z" fill="#EA637A"/>
    <path d="M30 55H25V60H30V55Z" fill="#EA637A"/>
    <path d="M30 50H25V55H30V50Z" fill="#EA637A"/>
    <path d="M30 35H25V40H30V35Z" fill="#F7F5F0"/>
    <path d="M25 55H20V60H25V55Z" fill="#EA637A"/>
    <path d="M25 50H20V55H25V50Z" fill="#EA637A"/>
    <path d="M25 30H20V35H25V30Z" fill="#353433"/>
    <path d="M25 25H20V30H25V25Z" fill="#353433"/>
    <path d="M20 55H15V60H20V55Z" fill="#EA637A"/>
    <path d="M20 50H15V55H20V50Z" fill="#EA637A"/>
    <path d="M45 60H40V65H45V60Z" fill="#FFE6EA"/>
    <path d="M40 60H35V65H40V60Z" fill="#FFE6EA"/>
    <path d="M35 60H30V65H35V60Z" fill="#FFE6EA"/>
    <path d="M30 60H25V65H30V60Z" fill="#FFE6EA"/>
    <path d="M45 70H40V75H45V70Z" fill="#FFE6EA"/>
    <path d="M40 70H35V75H40V70Z" fill="#FFE6EA"/>
    <path d="M35 70H30V75H35V70Z" fill="#FFE6EA"/>
    <path d="M30 70H25V75H30V70Z" fill="#FFE6EA"/>
    <path d="M65 30H60V35H65V30Z" fill="#DDAFB9"/>
    <path d="M65 25H60V30H65V25Z" fill="#DDAFB9"/>
    <path d="M65 20H60V25H65V20Z" fill="#DDAFB9"/>
    <path d="M60 30H55V35H60V30Z" fill="#DDAFB9"/>
    <path d="M60 25H55V30H60V25Z" fill="#DDAFB9"/>
    <path d="M60 20H55V25H60V20Z" fill="#DDAFB9"/>
    <path d="M60 15H55V20H60V15Z" fill="#DDAFB9"/>
    <path d="M60 10H55V15H60V10Z" fill="#DDAFB9"/>
    <path d="M60 5H55V10H60V5Z" fill="#DDAFB9"/>
    <path d="M55 50H50V55H55V50Z" fill="#333333"/>
    <path d="M55 45H50V50H55V45Z" fill="#333333"/>
    <path d="M55 40H50V45H55V40Z" fill="#333333"/>
    <path d="M55 35H50V40H55V35Z" fill="#333333"/>
    <path d="M55 30H50V35H55V30Z" fill="#333333"/>
    <path d="M55 25H50V30H55V25Z" fill="#333333"/>
    <path d="M55 20H50V25H55V20Z" fill="#333333"/>
    <path d="M55 15H50V20H55V15Z" fill="#333333"/>
    <path d="M55 10H50V15H55V10Z" fill="#333333"/>
    <path d="M55 5H50V10H55V5Z" fill="#DDAFB9"/>
    <path d="M55 0H50V5H55V0Z" fill="#DDAFB9"/>
    <path d="M50 15H45V20H50V15Z" fill="#333333"/>
    <path d="M50 10H45V15H50V10Z" fill="#333333"/>
    <path d="M50 5H45V10H50V5Z" fill="#333333"/>
    <path d="M50 0H45V5H50V0Z" fill="#DDAFB9"/>
    <path d="M45 10H40V15H45V10Z" fill="#333333"/>
    <path d="M45 5H40V10H45V5Z" fill="#333333"/>
    <path d="M45 0H40V5H45V0Z" fill="#DDAFB9"/>
    <path d="M40 10H35V15H40V10Z" fill="#333333"/>
    <path d="M40 5H35V10H40V5Z" fill="#333333"/>
    <path d="M40 0H35V5H40V0Z" fill="#DDAFB9"/>
    <path d="M35 10H30V15H35V10Z" fill="#333333"/>
    <path d="M35 5H30V10H35V5Z" fill="#333333"/>
    <path d="M35 0H30V5H35V0Z" fill="#DDAFB9"/>
    <path d="M30 10H25V15H30V10Z" fill="#333333"/>
    <path d="M30 5H25V10H30V5Z" fill="#333333"/>
    <path d="M30 0H25V5H30V0Z" fill="#DDAFB9"/>
    <path d="M25 10H20V15H25V10Z" fill="#333333"/>
    <path d="M25 5H20V10H25V5Z" fill="#333333"/>
    <path d="M25 0H20V5H25V0Z" fill="#DDAFB9"/>
    <path d="M20 15H15V20H20V15Z" fill="#333333"/>
    <path d="M20 10H15V15H20V10Z" fill="#333333"/>
    <path d="M20 5H15V10H20V5Z" fill="#333333"/>
    <path d="M20 0H15V5H20V0Z" fill="#DDAFB9"/>
    <path d="M15 50H10V55H15V50Z" fill="#333333"/>
    <path d="M15 45H10V50H15V45Z" fill="#333333"/>
    <path d="M15 40H10V45H15V40Z" fill="#333333"/>
    <path d="M15 35H10V40H15V35Z" fill="#333333"/>
    <path d="M15 30H10V35H15V30Z" fill="#333333"/>
    <path d="M15 25H10V30H15V25Z" fill="#333333"/>
    <path d="M15 20H10V25H15V20Z" fill="#333333"/>
    <path d="M15 15H10V20H15V15Z" fill="#333333"/>
    <path d="M15 10H10V15H15V10Z" fill="#333333"/>
    <path d="M15 5H10V10H15V5Z" fill="#DDAFB9"/>
    <path d="M15 0H10V5H15V0Z" fill="#DDAFB9"/>
    <path d="M10 30H5V35H10V30Z" fill="#DDAFB9"/>
    <path d="M10 25H5V30H10V25Z" fill="#DDAFB9"/>
    <path d="M10 20H5V25H10V20Z" fill="#DDAFB9"/>
    <path d="M10 15H5V20H10V15Z" fill="#DDAFB9"/>
    <path d="M10 10H5V15H10V10Z" fill="#DDAFB9"/>
    <path d="M10 5H5V10H10V5Z" fill="#DDAFB9"/>
    <path d="M5 30H0V35H5V30Z" fill="#DDAFB9"/>
    <path d="M5 25H0V30H5V25Z" fill="#DDAFB9"/>
    <path d="M5 20H0V25H5V20Z" fill="#DDAFB9"/>
    <path d="M45 5H40V10H45V5Z" fill="#3F3F3F"/>
    <path d="M25 5H20V10H25V5Z" fill="#3F3F3F"/>
    <path d="M20 5H15V10H20V5Z" fill="#3F3F3F"/>
    <path d="M20 10H15V15H20V10Z" fill="#3F3F3F"/>
    <path d="M15 40H10V45H15V40Z" fill="#3F3F3F"/>
    <path d="M15 25H10V30H15V25Z" fill="#3F3F3F"/>
    <path d="M15 35H10V40H15V35Z" fill="#3F3F3F"/>
    <path d="M15 30H10V35H15V30Z" fill="#3F3F3F"/>
    <path d="M15 15H10V20H15V15Z" fill="#3F3F3F"/>
    <path d="M15 10H10V15H15V10Z" fill="#3F3F3F"/>
    <path d="M15 20H10V25H15V20Z" fill="#3F3F3F"/>
    <path d="M35 5H30V10H35V5Z" fill="#3F3F3F"/>
    <path d="M30 5H25V10H30V5Z" fill="#3F3F3F"/>
    <path d="M65 45H60V50H65V45Z" fill="#E25271"/>
    <path d="M60 50H55V55H60V50Z" fill="#E25271"/>
    <path d="M55 55H50V60H55V55Z" fill="#E25271"/>
    <path d="M50 100H45V105H50V100Z" fill="#9E6C43"/>
    <path d="M50 95H45V100H50V95Z" fill="#9E6C43"/>
    <path d="M50 90H45V95H50V90Z" fill="#9E6C43"/>
    <path d="M50 55H45V60H50V55Z" fill="#E25271"/>
    <path d="M45 85H40V90H45V85Z" fill="#49545B"/>
    <path d="M45 80H40V85H45V80Z" fill="#49545B"/>
    <path d="M45 75H40V80H45V75Z" fill="#49545B"/>
    <path d="M45 70H40V75H45V70Z" fill="#E8CFD3"/>
    <path d="M45 65H40V70H45V65Z" fill="#E25271"/>
    <path d="M45 60H40V65H45V60Z" fill="#E8CFD3"/>
    <path d="M45 55H40V60H45V55Z" fill="#E25271"/>
    <path d="M40 75H35V80H40V75Z" fill="#49545B"/>
    <path d="M35 75H30V80H35V75Z" fill="#6A7277"/>
    <path d="M30 100H25V105H30V100Z" fill="#9E6C43"/>
    <path d="M30 95H25V100H30V95Z" fill="#9E6C43"/>
    <path d="M30 90H25V95H30V90Z" fill="#9E6C43"/>
    <path d="M30 85H25V90H30V85Z" fill="#6A7277"/>
    <path d="M30 80H25V85H30V80Z" fill="#6A7277"/>
    <path d="M30 75H25V80H30V75Z" fill="#6A7277"/>
    <path d="M25 100H20V105H25V100Z" fill="#9E6C43"/>
    <path d="M25 55H20V60H25V55Z" fill="#E25271"/>
    <path d="M20 55H15V60H20V55Z" fill="#E25271"/>
    <path d="M10 45H5V50H10V45Z" fill="#E25271"/>
    </svg>`;
  }

  cloud1() {
    return `<svg width="156" height="72" viewBox="0 0 156 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72 48H60V60H72V48Z" fill="#DFEDF7"/>
    <path d="M84 48H72V60H84V48Z" fill="#DFEDF7"/>
    <path d="M48 48H36V60H48V48Z" fill="#DFEDF7"/>
    <path d="M96 48H84V60H96V48Z" fill="#DFEDF7"/>
    <path d="M60 48H48V60H60V48Z" fill="#DFEDF7"/>
    <path d="M108 48H96V60H108V48Z" fill="#DFEDF7"/>
    <path d="M12 36H0V48H12V36Z" fill="#ACD4FC"/>
    <path d="M24 36H12V48H24V36Z" fill="#ACD4FC"/>
    <path d="M24 24H12V36H24V24Z" fill="#DFEDF7"/>
    <path d="M72 36H60V48H72V36Z" fill="#DFEDF7"/>
    <path d="M72 24H60V36H72V24Z" fill="#DFEDF7"/>
    <path d="M72 12H60V24H72V12Z" fill="#ACD4FC"/>
    <path d="M120 36H108V48H120V36Z" fill="#ACD4FC"/>
    <path d="M120 24H108V36H120V24Z" fill="#DFEDF7"/>
    <path d="M120 12H108V24H120V12Z" fill="#ACD4FC"/>
    <path d="M120 0H108V12H120V0Z" fill="#ACD4FC"/>
    <path d="M36 36H24V48H36V36Z" fill="#DFEDF7"/>
    <path d="M36 24H24V36H36V24Z" fill="#DFEDF7"/>
    <path d="M36 12H24V24H36V12Z" fill="#ACD4FC"/>
    <path d="M84 36H72V48H84V36Z" fill="#DFEDF7"/>
    <path d="M84 24H72V36H84V24Z" fill="#DFEDF7"/>
    <path d="M84 12H72V24H84V12Z" fill="#ACD4FC"/>
    <path d="M84 0H72V12H84V0Z" fill="#ACD4FC"/>
    <path d="M48 36H36V48H48V36Z" fill="#DFEDF7"/>
    <path d="M48 24H36V36H48V24Z" fill="#DFEDF7"/>
    <path d="M48 12H36V24H48V12Z" fill="#ACD4FC"/>
    <path d="M96 36H84V48H96V36Z" fill="#ACD4FC"/>
    <path d="M96 24H84V36H96V24Z" fill="#DFEDF7"/>
    <path d="M96 12H84V24H96V12Z" fill="#ACD4FC"/>
    <path d="M96 0H84V12H96V0Z" fill="#ACD4FC"/>
    <path d="M60 36H48V48H60V36Z" fill="#DFEDF7"/>
    <path d="M60 24H48V36H60V24Z" fill="#DFEDF7"/>
    <path d="M60 12H48V24H60V12Z" fill="#ACD4FC"/>
    <path d="M108 36H96V48H108V36Z" fill="#ACD4FC"/>
    <path d="M108 24H96V36H108V24Z" fill="#DFEDF7"/>
    <path d="M108 12H96V24H108V12Z" fill="#ACD4FC"/>
    <path d="M108 0H96V12H108V0Z" fill="#ACD4FC"/>
    <path d="M132 36H120V48H132V36Z" fill="#ACD4FC"/>
    <path d="M132 24H120V36H132V24Z" fill="#DFEDF7"/>
    <path d="M132 12H120V24H132V12Z" fill="#DFEDF7"/>
    <path d="M144 36H132V48H144V36Z" fill="#ACD4FC"/>
    <path d="M144 12H132V24H144V12Z" fill="#DFEDF7"/>
    <path d="M156 36H144V48H156V36Z" fill="#ACD4FC"/>
    <path d="M156 12H144V24H156V12Z" fill="#DFEDF7"/>
    <path d="M24 60H12V72H24V60Z" fill="#DFEDF7"/>
    <path d="M36 60H24V72H36V60Z" fill="#DFEDF7"/>
    <path d="M48 60H36V72H48V60Z" fill="#DFEDF7"/>
    </svg>`;
  }

  cloud2() {
    return `<svg width="130" height="60" viewBox="0 0 130 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M120 30H110V40H120V30Z" fill="#DFEDF6"/>
    <path d="M110 40H100V50H110V40Z" fill="#ACD4FC"/>
    <path d="M110 30H100V40H110V30Z" fill="#DFEDF6"/>
    <path d="M100 40H90V50H100V40Z" fill="#ACD4FC"/>
    <path d="M100 30H90V40H100V30Z" fill="#DFEDF6"/>
    <path d="M90 40H80V50H90V40Z" fill="#ACD4FC"/>
    <path d="M90 30H80V40H90V30Z" fill="#DFEDF6"/>
    <path d="M80 40H70V50H80V40Z" fill="#ACD4FC"/>
    <path d="M80 30H70V40H80V30Z" fill="#DFEDF6"/>
    <path d="M70 50H60V60H70V50Z" fill="#ACD4FC"/>
    <path d="M70 40H60V50H70V40Z" fill="#ACD4FC"/>
    <path d="M70 30H60V40H70V30Z" fill="#DFEDF6"/>
    <path d="M60 50H50V60H60V50Z" fill="#ACD4FC"/>
    <path d="M60 40H50V50H60V40Z" fill="#ACD4FC"/>
    <path d="M60 30H50V40H60V30Z" fill="#DFEDF6"/>
    <path d="M50 50H40V60H50V50Z" fill="#ACD4FC"/>
    <path d="M50 40H40V50H50V40Z" fill="#ACD4FC"/>
    <path d="M50 30H40V40H50V30Z" fill="#DFEDF6"/>
    <path d="M40 50H30V60H40V50Z" fill="#ACD4FC"/>
    <path d="M40 40H30V50H40V40Z" fill="#ACD4FC"/>
    <path d="M40 30H30V40H40V30Z" fill="#DFEDF6"/>
    <path d="M30 40H20V50H30V40Z" fill="#DFEDF6"/>
    <path d="M20 40H10V50H20V40Z" fill="#DFEDF6"/>
    <path d="M130 20H120V30H130V20Z" fill="#ACD4FC"/>
    <path d="M120 20H110V30H120V20Z" fill="#ACD4FC"/>
    <path d="M110 20H100V30H110V20Z" fill="#ACD4FC"/>
    <path d="M110 0H100V10H110V0Z" fill="#DFEDF6"/>
    <path d="M100 20H90V30H100V20Z" fill="#DFEDF6"/>
    <path d="M100 10H90V20H100V10Z" fill="#DFEDF6"/>
    <path d="M100 0H90V10H100V0Z" fill="#DFEDF6"/>
    <path d="M90 20H80V30H90V20Z" fill="#DFEDF6"/>
    <path d="M90 10H80V20H90V10Z" fill="#DFEDF6"/>
    <path d="M90 0H80V10H90V0Z" fill="#DFEDF6"/>
    <path d="M80 20H70V30H80V20Z" fill="#DFEDF6"/>
    <path d="M80 10H70V20H80V10Z" fill="#DFEDF6"/>
    <path d="M70 20H60V30H70V20Z" fill="#DFEDF6"/>
    <path d="M70 10H60V20H70V10Z" fill="#DFEDF6"/>
    <path d="M60 20H50V30H60V20Z" fill="#ACD4FC"/>
    <path d="M60 10H50V20H60V10Z" fill="#DFEDF6"/>
    <path d="M50 20H40V30H50V20Z" fill="#ACD4FC"/>
    <path d="M50 10H40V20H50V10Z" fill="#DFEDF6"/>
    <path d="M40 20H30V30H40V20Z" fill="#ACD4FC"/>
    <path d="M30 20H20V30H30V20Z" fill="#ACD4FC"/>
    <path d="M20 20H10V30H20V20Z" fill="#ACD4FC"/>
    <path d="M10 20H0V30H10V20Z" fill="#DFEDF6"/>
    </svg>`;
  }

  cloud3() {
    return `<svg width="160" height="80" viewBox="0 0 160 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M90 0H80V10H90V0Z" fill="#DFEDF7"/>
    <path d="M60 0H50V10H60V0Z" fill="#DFEDF7"/>
    <path d="M70 0H60V10H70V0Z" fill="#DFEDF7"/>
    <path d="M80 0H70V10H80V0Z" fill="#DFEDF7"/>
    <path d="M30 10H20V20H30V10Z" fill="#ACD4FC"/>
    <path d="M40 10H30V20H40V10Z" fill="#ACD4FC"/>
    <path d="M50 10H40V20H50V10Z" fill="#ACD4FC"/>
    <path d="M90 10H80V20H90V10Z" fill="#DFEDF7"/>
    <path d="M130 10H120V20H130V10Z" fill="#DFEDF7"/>
    <path d="M60 10H50V20H60V10Z" fill="#DFEDF7"/>
    <path d="M100 10H90V20H100V10Z" fill="#ACD4FC"/>
    <path d="M140 10H130V20H140V10Z" fill="#DFEDF7"/>
    <path d="M70 10H60V20H70V10Z" fill="#DFEDF7"/>
    <path d="M110 10H100V20H110V10Z" fill="#ACD4FC"/>
    <path d="M80 10H70V20H80V10Z" fill="#DFEDF7"/>
    <path d="M120 10H110V20H120V10Z" fill="#DFEDF7"/>
    <path d="M20 20H10V30H20V20Z" fill="#DFEDF7"/>
    <path d="M20 40H10V50H20V40Z" fill="#DFEDF7"/>
    <path d="M30 20H20V30H30V20Z" fill="#DFEDF7"/>
    <path d="M30 40H20V50H30V40Z" fill="#DFEDF7"/>
    <path d="M40 20H30V30H40V20Z" fill="#DFEDF7"/>
    <path d="M40 30H30V40H40V30Z" fill="#DFEDF7"/>
    <path d="M40 40H30V50H40V40Z" fill="#DFEDF7"/>
    <path d="M50 20H40V30H50V20Z" fill="#DFEDF7"/>
    <path d="M50 30H40V40H50V30Z" fill="#DFEDF7"/>
    <path d="M50 40H40V50H50V40Z" fill="#DFEDF7"/>
    <path d="M90 20H80V30H90V20Z" fill="#DFEDF7"/>
    <path d="M90 30H80V40H90V30Z" fill="#DFEDF7"/>
    <path d="M90 40H80V50H90V40Z" fill="#DFEDF7"/>
    <path d="M130 20H120V30H130V20Z" fill="#DFEDF7"/>
    <path d="M130 30H120V40H130V30Z" fill="#DFEDF7"/>
    <path d="M130 40H120V50H130V40Z" fill="#ACD4FC"/>
    <path d="M60 20H50V30H60V20Z" fill="#ACD4FC"/>
    <path d="M60 30H50V40H60V30Z" fill="#DFEDF7"/>
    <path d="M60 40H50V50H60V40Z" fill="#DFEDF7"/>
    <path d="M100 20H90V30H100V20Z" fill="#DFEDF7"/>
    <path d="M100 30H90V40H100V30Z" fill="#DFEDF7"/>
    <path d="M100 40H90V50H100V40Z" fill="#DFEDF7"/>
    <path d="M140 20H130V30H140V20Z" fill="#DFEDF7"/>
    <path d="M140 40H130V50H140V40Z" fill="#ACD4FC"/>
    <path d="M70 20H60V30H70V20Z" fill="#ACD4FC"/>
    <path d="M70 30H60V40H70V30Z" fill="#DFEDF7"/>
    <path d="M70 40H60V50H70V40Z" fill="#DFEDF7"/>
    <path d="M110 20H100V30H110V20Z" fill="#DFEDF7"/>
    <path d="M110 30H100V40H110V30Z" fill="#DFEDF7"/>
    <path d="M110 40H100V50H110V40Z" fill="#ACD4FC"/>
    <path d="M80 20H70V30H80V20Z" fill="#ACD4FC"/>
    <path d="M80 30H70V40H80V30Z" fill="#DFEDF7"/>
    <path d="M80 40H70V50H80V40Z" fill="#DFEDF7"/>
    <path d="M120 20H110V30H120V20Z" fill="#DFEDF7"/>
    <path d="M120 30H110V40H120V30Z" fill="#DFEDF7"/>
    <path d="M120 40H110V50H120V40Z" fill="#ACD4FC"/>
    <path d="M10 50H0V60H10V50Z" fill="#DFEDF7"/>
    <path d="M20 50H10V60H20V50Z" fill="#DFEDF7"/>
    <path d="M30 50H20V60H30V50Z" fill="#DFEDF7"/>
    <path d="M40 50H30V60H40V50Z" fill="#DFEDF7"/>
    <path d="M50 50H40V60H50V50Z" fill="#DFEDF7"/>
    <path d="M90 50H80V60H90V50Z" fill="#DFEDF7"/>
    <path d="M130 50H120V60H130V50Z" fill="#ACD4FC"/>
    <path d="M60 50H50V60H60V50Z" fill="#DFEDF7"/>
    <path d="M100 50H90V60H100V50Z" fill="#DFEDF7"/>
    <path d="M140 50H130V60H140V50Z" fill="#ACD4FC"/>
    <path d="M70 50H60V60H70V50Z" fill="#DFEDF7"/>
    <path d="M110 50H100V60H110V50Z" fill="#ACD4FC"/>
    <path d="M150 50H140V60H150V50Z" fill="#ACD4FC"/>
    <path d="M80 50H70V60H80V50Z" fill="#DFEDF7"/>
    <path d="M120 50H110V60H120V50Z" fill="#ACD4FC"/>
    <path d="M160 50H150V60H160V50Z" fill="#ACD4FC"/>
    <path d="M30 60H20V70H30V60Z" fill="#ACD4FC"/>
    <path d="M40 60H30V70H40V60Z" fill="#ACD4FC"/>
    <path d="M50 60H40V70H50V60Z" fill="#ACD4FC"/>
    <path d="M90 60H80V70H90V60Z" fill="#ACD4FC"/>
    <path d="M130 60H120V70H130V60Z" fill="#ACD4FC"/>
    <path d="M60 60H50V70H60V60Z" fill="#ACD4FC"/>
    <path d="M100 60H90V70H100V60Z" fill="#ACD4FC"/>
    <path d="M70 60H60V70H70V60Z" fill="#ACD4FC"/>
    <path d="M110 60H100V70H110V60Z" fill="#ACD4FC"/>
    <path d="M80 60H70V70H80V60Z" fill="#ACD4FC"/>
    <path d="M120 60H110V70H120V60Z" fill="#ACD4FC"/>
    <path d="M140 70H130V80H140V70Z" fill="#ACD4FC"/>
    </svg>`;
  }

  snow() {
    return `<svg width="686" height="184" viewBox="0 0 686 184" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M502.996 95.9985H494.996V104H502.996V95.9985Z" fill="#E6EDF4"/>
    <path d="M494.996 95.9985H486.996V104H494.996V95.9985Z" fill="#E6EDF4"/>
    <path d="M486.996 95.9985H478.996V104H486.996V95.9985Z" fill="#FEF8EA"/>
    <path d="M486.996 87.9986H478.996V95.9977H486.996V87.9986Z" fill="#E6EDF4"/>
    <path d="M478.996 95.9985H470.996V104H478.996V95.9985Z" fill="#FEF8EA"/>
    <path d="M478.996 87.9986H470.996V95.9977H478.996V87.9986Z" fill="#E6EDF4"/>
    <path d="M470.996 95.9985H462.996V104H470.996V95.9985Z" fill="#FEF8EA"/>
    <path d="M470.996 87.9986H462.996V95.9977H470.996V87.9986Z" fill="#E6EDF4"/>
    <path d="M462.996 95.9985H454.997V104H462.996V95.9985Z" fill="#FEF8EA"/>
    <path d="M462.996 87.9986H454.997V95.9977H462.996V87.9986Z" fill="#FEF8EA"/>
    <path d="M462.996 79.9987H454.997V87.9978H462.996V79.9987Z" fill="#E6EDF4"/>
    <path d="M454.997 95.9985H446.997V104H454.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M454.997 87.9986H446.997V95.9977H454.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M454.997 79.9987H446.997V87.9978H454.997V79.9987Z" fill="#E6EDF4"/>
    <path d="M446.997 95.9985H438.997V104H446.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M446.997 87.9986H438.997V95.9977H446.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M446.997 79.9987H438.997V87.9978H446.997V79.9987Z" fill="#E6EDF4"/>
    <path d="M438.997 95.9985H430.997V104H438.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M438.997 87.9986H430.997V95.9977H438.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M438.997 79.9987H430.997V87.9978H438.997V79.9987Z" fill="#E6EDF4"/>
    <path d="M430.997 95.9985H422.997V104H430.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M430.997 87.9986H422.997V95.9977H430.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M430.997 79.9987H422.997V87.9978H430.997V79.9987Z" fill="#FEF8EA"/>
    <path d="M430.997 71.9989H422.997V79.998H430.997V71.9989Z" fill="#E6EDF4"/>
    <path d="M422.997 95.9985H414.997V104H422.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M422.997 87.9986H414.997V95.9977H422.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M422.997 79.9987H414.997V87.9978H422.997V79.9987Z" fill="#FEF8EA"/>
    <path d="M422.997 71.9989H414.997V79.998H422.997V71.9989Z" fill="#FEF8EA"/>
    <path d="M422.997 63.999H414.997V72.0006H422.997V63.999Z" fill="#E6EDF4"/>
    <path d="M414.997 95.9985H406.997V104H414.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M414.997 87.9986H406.997V95.9977H414.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M414.997 79.9987H406.997V87.9978H414.997V79.9987Z" fill="#FEF8EA"/>
    <path d="M414.997 71.9989H406.997V79.998H414.997V71.9989Z" fill="#FEF8EA"/>
    <path d="M414.997 63.999H406.997V72.0006H414.997V63.999Z" fill="#E6EDF4"/>
    <path d="M406.997 95.9985H398.997V104H406.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M406.997 87.9986H398.997V95.9977H406.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M406.997 79.9987H398.997V87.9978H406.997V79.9987Z" fill="#FEF8EA"/>
    <path d="M406.997 71.9989H398.997V79.998H406.997V71.9989Z" fill="#FEF8EA"/>
    <path d="M406.997 63.999H398.997V72.0006H406.997V63.999Z" fill="#FEF8EA"/>
    <path d="M406.997 55.9991H398.997V63.9983H406.997V55.9991Z" fill="#E6EDF4"/>
    <path d="M398.997 95.9985H390.997V104H398.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M398.997 87.9986H390.997V95.9977H398.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M398.997 79.9987H390.997V87.9978H398.997V79.9987Z" fill="#FEF8EA"/>
    <path d="M398.997 71.9989H390.997V79.998H398.997V71.9989Z" fill="#FEF8EA"/>
    <path d="M398.997 63.999H390.997V72.0006H398.997V63.999Z" fill="#FEF8EA"/>
    <path d="M398.997 55.9991H390.997V63.9983H398.997V55.9991Z" fill="#FEF8EA"/>
    <path d="M398.997 47.9993H390.997V55.9984H398.997V47.9993Z" fill="#E6EDF4"/>
    <path d="M390.997 95.9985H382.998V104H390.997V95.9985Z" fill="#FEF8EA"/>
    <path d="M390.997 87.9986H382.998V95.9977H390.997V87.9986Z" fill="#FEF8EA"/>
    <path d="M390.997 79.9987H382.998V87.9978H390.997V79.9987Z" fill="#FEF8EA"/>
    <path d="M390.997 71.9989H382.998V79.998H390.997V71.9989Z" fill="#FEF8EA"/>
    <path d="M390.997 63.999H382.998V72.0006H390.997V63.999Z" fill="#FEF8EA"/>
    <path d="M390.997 55.9991H382.998V63.9983H390.997V55.9991Z" fill="#FEF8EA"/>
    <path d="M390.997 47.9993H382.998V55.9984H390.997V47.9993Z" fill="#FEF8EA"/>
    <path d="M390.997 39.9994H382.998V47.9985H390.997V39.9994Z" fill="#E6EDF4"/>
    <path d="M390.997 31.9995H382.998V40.001H390.997V31.9995Z" fill="#E6EDF4"/>
    <path d="M382.998 95.9985H374.998V104H382.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M382.998 87.9986H374.998V95.9977H382.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M382.998 79.9987H374.998V87.9978H382.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M382.998 71.9989H374.998V79.998H382.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M382.998 63.999H374.998V72.0006H382.998V63.999Z" fill="#FEF8EA"/>
    <path d="M382.998 55.9991H374.998V63.9983H382.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M382.998 47.9993H374.998V55.9984H382.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M382.998 39.9994H374.998V47.9985H382.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M382.998 31.9995H374.998V40.001H382.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M382.998 23.9996H374.998V31.9987H382.998V23.9996Z" fill="#E6EDF4"/>
    <path d="M374.998 95.9985H366.998V104H374.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M374.998 87.9986H366.998V95.9977H374.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M374.998 79.9987H366.998V87.9978H374.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M374.998 71.9989H366.998V79.998H374.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M374.998 63.999H366.998V72.0006H374.998V63.999Z" fill="#FEF8EA"/>
    <path d="M374.998 55.9991H366.998V63.9983H374.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M374.998 47.9993H366.998V55.9984H374.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M374.998 39.9994H366.998V47.9985H374.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M374.998 31.9995H366.998V40.001H374.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M374.998 23.9996H366.998V31.9987H374.998V23.9996Z" fill="#E6EDF4"/>
    <path d="M374.998 15.9998H366.998V23.9989H374.998V15.9998Z" fill="#E6EDF4"/>
    <path d="M374.998 7.99988H366.998V15.999H374.998V7.99988Z" fill="#DAE5F2"/>
    <path d="M366.998 95.9985H358.998V104H366.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M366.998 87.9986H358.998V95.9977H366.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M366.998 79.9987H358.998V87.9978H366.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M366.998 71.9989H358.998V79.998H366.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M366.998 63.999H358.998V72.0006H366.998V63.999Z" fill="#FEF8EA"/>
    <path d="M366.998 55.9991H358.998V63.9983H366.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M366.998 47.9993H358.998V55.9984H366.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M366.998 39.9994H358.998V47.9985H366.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M366.998 31.9995H358.998V40.001H366.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M366.998 23.9996H358.998V31.9987H366.998V23.9996Z" fill="#FEF8EA"/>
    <path d="M366.998 15.9998H358.998V23.9989H366.998V15.9998Z" fill="#E6EDF4"/>
    <path d="M366.998 7.99988H358.998V15.999H366.998V7.99988Z" fill="#DAE5F2"/>
    <path d="M358.998 95.9985H350.998V104H358.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M358.998 87.9986H350.998V95.9977H358.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M358.998 79.9987H350.998V87.9978H358.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M358.998 71.9989H350.998V79.998H358.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M358.998 63.999H350.998V72.0006H358.998V63.999Z" fill="#FEF8EA"/>
    <path d="M358.998 55.9991H350.998V63.9983H358.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M358.998 47.9993H350.998V55.9984H358.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M358.998 39.9994H350.998V47.9985H358.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M358.998 31.9995H350.998V40.001H358.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M358.998 23.9996H350.998V31.9987H358.998V23.9996Z" fill="#FEF8EA"/>
    <path d="M358.998 15.9998H350.998V23.9989H358.998V15.9998Z" fill="#E6EDF4"/>
    <path d="M358.998 7.99988H350.998V15.999H358.998V7.99988Z" fill="#E6EDF4"/>
    <path d="M358.998 0H350.998V8.00153H358.998V0Z" fill="#DAE5F2"/>
    <path d="M350.998 95.9985H342.998V104H350.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M350.998 87.9986H342.998V95.9977H350.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M350.998 79.9987H342.998V87.9978H350.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M350.998 71.9989H342.998V79.998H350.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M350.998 63.999H342.998V72.0006H350.998V63.999Z" fill="#FEF8EA"/>
    <path d="M350.998 55.9991H342.998V63.9983H350.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M350.998 47.9993H342.998V55.9984H350.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M350.998 39.9994H342.998V47.9985H350.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M350.998 31.9995H342.998V40.001H350.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M350.998 23.9996H342.998V31.9987H350.998V23.9996Z" fill="#FEF8EA"/>
    <path d="M350.998 15.9998H342.998V23.9989H350.998V15.9998Z" fill="#FEF8EA"/>
    <path d="M350.998 7.99988H342.998V15.999H350.998V7.99988Z" fill="#E6EDF4"/>
    <path d="M350.998 0H342.998V8.00153H350.998V0Z" fill="#DAE5F2"/>
    <path d="M342.998 95.9985H334.998V104H342.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M342.998 87.9986H334.998V95.9977H342.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M342.998 79.9987H334.998V87.9978H342.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M342.998 71.9989H334.998V79.998H342.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M342.998 63.999H334.998V72.0006H342.998V63.999Z" fill="#FEF8EA"/>
    <path d="M342.998 55.9991H334.998V63.9983H342.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M342.998 47.9993H334.998V55.9984H342.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M342.998 39.9994H334.998V47.9985H342.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M342.998 31.9995H334.998V40.001H342.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M342.998 23.9996H334.998V31.9987H342.998V23.9996Z" fill="#FEF8EA"/>
    <path d="M342.998 15.9998H334.998V23.9989H342.998V15.9998Z" fill="#E6EDF4"/>
    <path d="M342.998 7.99988H334.998V15.999H342.998V7.99988Z" fill="#E6EDF4"/>
    <path d="M342.998 0H334.998V8.00153H342.998V0Z" fill="#DAE5F2"/>
    <path d="M334.998 95.9985H326.999V104H334.998V95.9985Z" fill="#FEF8EA"/>
    <path d="M334.998 87.9986H326.999V95.9977H334.998V87.9986Z" fill="#FEF8EA"/>
    <path d="M334.998 79.9987H326.999V87.9978H334.998V79.9987Z" fill="#FEF8EA"/>
    <path d="M334.998 71.9989H326.999V79.998H334.998V71.9989Z" fill="#FEF8EA"/>
    <path d="M334.998 63.999H326.999V72.0006H334.998V63.999Z" fill="#FEF8EA"/>
    <path d="M334.998 55.9991H326.999V63.9983H334.998V55.9991Z" fill="#FEF8EA"/>
    <path d="M334.998 47.9993H326.999V55.9984H334.998V47.9993Z" fill="#FEF8EA"/>
    <path d="M334.998 39.9994H326.999V47.9985H334.998V39.9994Z" fill="#FEF8EA"/>
    <path d="M334.998 31.9995H326.999V40.001H334.998V31.9995Z" fill="#FEF8EA"/>
    <path d="M334.998 23.9996H326.999V31.9987H334.998V23.9996Z" fill="#FEF8EA"/>
    <path d="M334.998 15.9998H326.999V23.9989H334.998V15.9998Z" fill="#E6EDF4"/>
    <path d="M334.998 7.99988H326.999V15.999H334.998V7.99988Z" fill="#DAE5F2"/>
    <path d="M334.998 0H326.999V8.00153H334.998V0Z" fill="#DAE5F2"/>
    <path d="M326.999 95.9985H318.999V104H326.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M326.999 87.9986H318.999V95.9977H326.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M326.999 79.9987H318.999V87.9978H326.999V79.9987Z" fill="#FEF8EA"/>
    <path d="M326.999 71.9989H318.999V79.998H326.999V71.9989Z" fill="#FEF8EA"/>
    <path d="M326.999 63.999H318.999V72.0006H326.999V63.999Z" fill="#FEF8EA"/>
    <path d="M326.999 55.9991H318.999V63.9983H326.999V55.9991Z" fill="#FEF8EA"/>
    <path d="M326.999 47.9993H318.999V55.9984H326.999V47.9993Z" fill="#FEF8EA"/>
    <path d="M326.999 39.9994H318.999V47.9985H326.999V39.9994Z" fill="#FEF8EA"/>
    <path d="M326.999 31.9995H318.999V40.001H326.999V31.9995Z" fill="#FEF8EA"/>
    <path d="M326.999 23.9996H318.999V31.9987H326.999V23.9996Z" fill="#E6EDF4"/>
    <path d="M326.999 15.9998H318.999V23.9989H326.999V15.9998Z" fill="#DAE5F2"/>
    <path d="M326.999 7.99988H318.999V15.999H326.999V7.99988Z" fill="#DAE5F2"/>
    <path d="M318.999 95.9985H310.999V104H318.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M318.999 87.9986H310.999V95.9977H318.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M318.999 79.9987H310.999V87.9978H318.999V79.9987Z" fill="#FEF8EA"/>
    <path d="M318.999 71.9989H310.999V79.998H318.999V71.9989Z" fill="#FEF8EA"/>
    <path d="M318.999 63.999H310.999V72.0006H318.999V63.999Z" fill="#FEF8EA"/>
    <path d="M318.999 55.9991H310.999V63.9983H318.999V55.9991Z" fill="#FEF8EA"/>
    <path d="M318.999 47.9993H310.999V55.9984H318.999V47.9993Z" fill="#FEF8EA"/>
    <path d="M318.999 39.9994H310.999V47.9985H318.999V39.9994Z" fill="#E6EDF4"/>
    <path d="M318.999 31.9995H310.999V40.001H318.999V31.9995Z" fill="#E6EDF4"/>
    <path d="M318.999 23.9996H310.999V31.9987H318.999V23.9996Z" fill="#DAE5F2"/>
    <path d="M318.999 15.9998H310.999V23.9989H318.999V15.9998Z" fill="#DAE5F2"/>
    <path d="M310.999 95.9985H302.999V104H310.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M310.999 87.9986H302.999V95.9977H310.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M310.999 79.9987H302.999V87.9978H310.999V79.9987Z" fill="#FEF8EA"/>
    <path d="M310.999 71.9989H302.999V79.998H310.999V71.9989Z" fill="#FEF8EA"/>
    <path d="M310.999 63.999H302.999V72.0006H310.999V63.999Z" fill="#FEF8EA"/>
    <path d="M310.999 55.9991H302.999V63.9983H310.999V55.9991Z" fill="#FEF8EA"/>
    <path d="M310.999 47.9993H302.999V55.9984H310.999V47.9993Z" fill="#E6EDF4"/>
    <path d="M310.999 39.9994H302.999V47.9985H310.999V39.9994Z" fill="#DAE5F2"/>
    <path d="M310.999 31.9995H302.999V40.001H310.999V31.9995Z" fill="#DAE5F2"/>
    <path d="M302.999 95.9985H294.999V104H302.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M302.999 87.9986H294.999V95.9977H302.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M302.999 79.9987H294.999V87.9978H302.999V79.9987Z" fill="#FEF8EA"/>
    <path d="M302.999 71.9989H294.999V79.998H302.999V71.9989Z" fill="#FEF8EA"/>
    <path d="M302.999 63.999H294.999V72.0006H302.999V63.999Z" fill="#FEF8EA"/>
    <path d="M302.999 55.9991H294.999V63.9983H302.999V55.9991Z" fill="#E6EDF4"/>
    <path d="M302.999 47.9993H294.999V55.9984H302.999V47.9993Z" fill="#DAE5F2"/>
    <path d="M294.999 95.9985H286.999V104H294.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M294.999 87.9986H286.999V95.9977H294.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M294.999 79.9987H286.999V87.9978H294.999V79.9987Z" fill="#FEF8EA"/>
    <path d="M294.999 71.9989H286.999V79.998H294.999V71.9989Z" fill="#FEF8EA"/>
    <path d="M294.999 63.999H286.999V72.0006H294.999V63.999Z" fill="#E6EDF4"/>
    <path d="M279 63.999H271V72.0006H279V63.999Z" fill="#E6EDF4"/>
    <path d="M294.999 55.9991H286.999V63.9983H294.999V55.9991Z" fill="#DAE5F2"/>
    <path d="M286.999 95.9985H278.999V104H286.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M286.999 87.9986H278.999V95.9977H286.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M286.999 79.9987H278.999V87.9978H286.999V79.9987Z" fill="#FEF8EA"/>
    <path d="M286.999 71.9989H278.999V79.998H286.999V71.9989Z" fill="#E6EDF4"/>
    <path d="M286.999 63.999H278.999V72.0006H286.999V63.999Z" fill="#DAE5F2"/>
    <path d="M278.999 95.9985H270.999V104H278.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M278.999 87.9986H270.999V95.9977H278.999V87.9986Z" fill="#FEF8EA"/>
    <path d="M278.999 79.9987H270.999V87.9978H278.999V79.9987Z" fill="#E6EDF4"/>
    <path d="M278.999 71.9989H270.999V79.998H278.999V71.9989Z" fill="#DAE5F2"/>
    <path d="M270.999 95.9985H263V104H270.999V95.9985Z" fill="#FEF8EA"/>
    <path d="M270.999 87.9986H263V95.9977H270.999V87.9986Z" fill="#E6EDF4"/>
    <path d="M270.999 79.9987H263V87.9978H270.999V79.9987Z" fill="#DAE5F2"/>
    <path d="M263 95.9985H255V104H263V95.9985Z" fill="#FEF8EA"/>
    <path d="M263 87.9986H255V95.9977H263V87.9986Z" fill="#DAE5F2"/>
    <path d="M255 95.9985H247V104H255V95.9985Z" fill="#E6EDF4"/>
    <path d="M247 95.9985H239V104H247V95.9985Z" fill="#DAE5F2"/>
    <path d="M239 95.9985H231V104H239V95.9985Z" fill="#DAE5F2"/>
    <path d="M383 112H375V120H383V112Z" fill="#FEF8EA"/>
    <path d="M375 120H367V128H375V120Z" fill="#FEF8EA"/>
    <path d="M375 112H367V120H375V112Z" fill="#FEF8EA"/>
    <path d="M367 128H359V136H367V128Z" fill="#FEF8EA"/>
    <path d="M367 120H359V128H367V120Z" fill="#FEF8EA"/>
    <path d="M367 112H359V120H367V112Z" fill="#FEF8EA"/>
    <path d="M367 104H359V112H367V104Z" fill="#FEF8EA"/>
    <path d="M359 112H351V120H359V112Z" fill="#FEF8EA"/>
    <path d="M359 104H351V112H359V104Z" fill="#FEF8EA"/>
    <path d="M359 128H351V136H359V128Z" fill="#FEF8EA"/>
    <path d="M359 120H351V128H359V120Z" fill="#FEF8EA"/>
    <path d="M351 112H343V120H351V112Z" fill="#FEF8EA"/>
    <path d="M351 128H343V136H351V128Z" fill="#FEF8EA"/>
    <path d="M351 120H343V128H351V120Z" fill="#FEF8EA"/>
    <path d="M343 112H335V120H343V112Z" fill="#FEF8EA"/>
    <path d="M343 128H335V136H343V128Z" fill="#FEF8EA"/>
    <path d="M335 128H327V136H335V128Z" fill="#FEF8EA"/>
    <path d="M327 128H319V136H327V128Z" fill="#FEF8EA"/>
    <path d="M327 136H319V144H327V136Z" fill="#FEF8EA"/>
    <path d="M319 136H311V144H319V136Z" fill="#FEF8EA"/>
    <path d="M319 120H311V128H319V120Z" fill="#FEF8EA"/>
    <path d="M311 144H303V152H311V144Z" fill="#FEF8EA"/>
    <path d="M311 136H303V144H311V136Z" fill="#FEF8EA"/>
    <path d="M311 120H303V128H311V120Z" fill="#FEF8EA"/>
    <path d="M303 144H295V152H303V144Z" fill="#FEF8EA"/>
    <path d="M303 136H295V144H303V136Z" fill="#FEF8EA"/>
    <path d="M303 128H295V136H303V128Z" fill="#FEF8EA"/>
    <path d="M295 144H287V152H295V144Z" fill="#FEF8EA"/>
    <path d="M303 120H295V128H303V120Z" fill="#FEF8EA"/>
    <path d="M287 144H279V152H287V144Z" fill="#FEF8EA"/>
    <path d="M295 136H287V144H295V136Z" fill="#FEF8EA"/>
    <path d="M295 128H287V136H295V128Z" fill="#FEF8EA"/>
    <path d="M295 120H287V128H295V120Z" fill="#FEF8EA"/>
    <path d="M279 144H271V152H279V144Z" fill="#FEF8EA"/>
    <path d="M287 136H279V144H287V136Z" fill="#FEF8EA"/>
    <path d="M287 128H279V136H287V128Z" fill="#FEF8EA"/>
    <path d="M287 120H279V128H287V120Z" fill="#FEF8EA"/>
    <path d="M271 144H263V152H271V144Z" fill="#FEF8EA"/>
    <path d="M279 136H271V144H279V136Z" fill="#FEF8EA"/>
    <path d="M279 128H271V136H279V128Z" fill="#FEF8EA"/>
    <path d="M279 120H271V128H279V120Z" fill="#FEF8EA"/>
    <path d="M263 144H255V152H263V144Z" fill="#FEF8EA"/>
    <path d="M271 136H263V144H271V136Z" fill="#FEF8EA"/>
    <path d="M271 120H263V128H271V120Z" fill="#FEF8EA"/>
    <path d="M263 136H255V144H263V136Z" fill="#FEF8EA"/>
    <path d="M255 144H247V152H255V144Z" fill="#FEF8EA"/>
    <path d="M247 144H239V152H247V144Z" fill="#FEF8EA"/>
    <path d="M239 144H231V152H239V144Z" fill="#FEF8EA"/>
    <path d="M231 128H223V136H231V128Z" fill="#FEF8EA"/>
    <path d="M239 152H231V160H239V152Z" fill="#FEF8EA"/>
    <path d="M247 152H239V160H247V152Z" fill="#FEF8EA"/>
    <path d="M247 160L255 160L255 168L247 168L247 160Z" fill="#FEF8EA"/>
    <path d="M255 168L263 168L263 176L255 176L255 168Z" fill="#FEF8EA"/>
    <path d="M255 160L263 160L263 168L255 168L255 160Z" fill="#FEF8EA"/>
    <path d="M247 152L255 152L255 160L247 160L247 152Z" fill="#FEF8EA"/>
    <path d="M263 168L271 168L271 176L263 176L263 168Z" fill="#FEF8EA"/>
    <path d="M263 160L271 160L271 168L263 168L263 160Z" fill="#FEF8EA"/>
    <path d="M223 152L231 152L231 160L223 160L223 152Z" fill="#FEF8EA"/>
    <path d="M271 176L279 176L279 184L271 184L271 176Z" fill="#FEF8EA"/>
    <path d="M271 168L279 168L279 176L271 176L271 168Z" fill="#FEF8EA"/>
    <path d="M271 160L279 160L279 168L271 168L271 160Z" fill="#FEF8EA"/>
    <path d="M279 176L287 176L287 184L279 184L279 176Z" fill="#FEF8EA"/>
    <path d="M279 168L287 168L287 176L279 176L279 168Z" fill="#FEF8EA"/>
    <path d="M287 176L295 176L295 184L287 184L287 176Z" fill="#FEF8EA"/>
    <path d="M287 168L295 168L295 176L287 176L287 168Z" fill="#FEF8EA"/>
    <path d="M287 160L295 160L295 168L287 168L287 160Z" fill="#FEF8EA"/>
    <path d="M295 160L303 160L303 168L295 168L295 160Z" fill="#FEF8EA"/>
    <path d="M295 176L303 176L303 184L295 184L295 176Z" fill="#FEF8EA"/>
    <path d="M303 168L311 168L311 176L303 176L303 168Z" fill="#FEF8EA"/>
    <path d="M311 176L319 176L319 184L311 184L311 176Z" fill="#FEF8EA"/>
    <path d="M311 168L319 168L319 176L311 176L311 168Z" fill="#FEF8EA"/>
    <path d="M367 152L375 152L375 160L367 160L367 152Z" fill="#FEF8EA"/>
    <path d="M319 176L327 176L327 184L319 184L319 176Z" fill="#FEF8EA"/>
    <path d="M319 168L327 168L327 176L319 176L319 168Z" fill="#FEF8EA"/>
    <path d="M319 160L327 160L327 168L319 168L319 160Z" fill="#FEF8EA"/>
    <path d="M319 152L327 152L327 160L319 160L319 152Z" fill="#FEF8EA"/>
    <path d="M327 160L335 160L335 168L327 168L327 160Z" fill="#FEF8EA"/>
    <path d="M335 160L343 160L343 168L335 168L335 160Z" fill="#FEF8EA"/>
    <path d="M343 160L351 160L351 168L343 168L343 160Z" fill="#FEF8EA"/>
    <path d="M351 160L359 160L359 168L351 168L351 160Z" fill="#FEF8EA"/>
    <path d="M359 160L367 160L367 168L359 168L359 160Z" fill="#FEF8EA"/>
    <path d="M327 176L335 176L335 184L327 184L327 176Z" fill="#FEF8EA"/>
    <path d="M335 176L343 176L343 184L335 184L335 176Z" fill="#FEF8EA"/>
    <path d="M343 176L351 176L351 184L343 184L343 176Z" fill="#FEF8EA"/>
    <path d="M359 176L367 176L367 184L359 184L359 176Z" fill="#FEF8EA"/>
    <path d="M367 176L375 176L375 184L367 184L367 176Z" fill="#FEF8EA"/>
    <path d="M375 176L383 176L383 184L375 184L375 176Z" fill="#FEF8EA"/>
    <path d="M383 176L391 176L391 184L383 184L383 176Z" fill="#FEF8EA"/>
    <path d="M397 176L405 176L405 184L397 184L397 176Z" fill="#FEF8EA"/>
    <path d="M327 168L335 168L335 176L327 176L327 168Z" fill="#FEF8EA"/>
    <path d="M335 168L343 168L343 176L335 176L335 168Z" fill="#FEF8EA"/>
    <path d="M343 168L351 168L351 176L343 176L343 168Z" fill="#FEF8EA"/>
    <path d="M351 168L359 168L359 176L351 176L351 168Z" fill="#FEF8EA"/>
    <path d="M12 58H6V64H12V58Z" fill="#FEF8EA"/>
    <path d="M18 58H12V64H18V58Z" fill="#FEF8EA"/>
    <path d="M24 58H18V64H24V58Z" fill="#FEF8EA"/>
    <path d="M30 58H24V64H30V58Z" fill="#FEF8EA"/>
    <path d="M36 58H30V64H36V58Z" fill="#FEF8EA"/>
    <path d="M42 58H36V64H42V58Z" fill="#FEF8EA"/>
    <path d="M144 52H138V58H144V52Z" fill="#FEF8EA"/>
    <path d="M138 52H132V58H138V52Z" fill="#FEF8EA"/>
    <path d="M132 52H126V58H132V52Z" fill="#FEF8EA"/>
    <path d="M126 52H120V58H126V52Z" fill="#FEF8EA"/>
    <path d="M120 52H114V58H120V52Z" fill="#E6EDF4"/>
    <path d="M114 52H108V58H114V52Z" fill="#E6EDF4"/>
    <path d="M108 52H102V58H108V52Z" fill="#E6EDF4"/>
    <path d="M162 52H156V58H162V52Z" fill="#FEF8EA"/>
    <path d="M168 52H162V58H168V52Z" fill="#FEF8EA"/>
    <path d="M156 52H150V58H156V52Z" fill="#E6EDF4"/>
    <path d="M150 52H144V58H150V52Z" fill="#E6EDF4"/>
    <path d="M144 46H138V52H144V46Z" fill="#FEF8EA"/>
    <path d="M138 46H132V52H138V46Z" fill="#FEF8EA"/>
    <path d="M132 46H126V52H132V46Z" fill="#FEF8EA"/>
    <path d="M126 46H120V52H126V46Z" fill="#FEF8EA"/>
    <path d="M6 64H0V70H6V64Z" fill="#FEF8EA"/>
    <path d="M12 64H6V70H12V64Z" fill="#FEF8EA"/>
    <path d="M18 64H12V70H18V64Z" fill="#FEF8EA"/>
    <path d="M24 64H18V70H24V64Z" fill="#FEF8EA"/>
    <path d="M30 64H24V70H30V64Z" fill="#FEF8EA"/>
    <path d="M36 64H30V70H36V64Z" fill="#FEF8EA"/>
    <path d="M108 58H102V64H108V58Z" fill="#FEF8EA"/>
    <path d="M102 58H96V64H102V58Z" fill="#FEF8EA"/>
    <path d="M114 58H108V64H114V58Z" fill="#FEF8EA"/>
    <path d="M120 58H114V64H120V58Z" fill="#FEF8EA"/>
    <path d="M120 64H114V70H120V64Z" fill="#FEF8EA"/>
    <path d="M126 64H120V70H126V64Z" fill="#FEF8EA"/>
    <path d="M132 64H126V70H132V64Z" fill="#FEF8EA"/>
    <path d="M138 64H132V70H138V64Z" fill="#FEF8EA"/>
    <path d="M144 64H138V70H144V64Z" fill="#FEF8EA"/>
    <path d="M150 64H144V70H150V64Z" fill="#FEF8EA"/>
    <path d="M156 64H150V70H156V64Z" fill="#FEF8EA"/>
    <path d="M162 64H156V70H162V64Z" fill="#FEF8EA"/>
    <path d="M114 70H108V76H114V70Z" fill="#FEF8EA"/>
    <path d="M120 70H114V76H120V70Z" fill="#FEF8EA"/>
    <path d="M126 70H120V76H126V70Z" fill="#FEF8EA"/>
    <path d="M132 70H126V76H132V70Z" fill="#FEF8EA"/>
    <path d="M138 70H132V76H138V70Z" fill="#FEF8EA"/>
    <path d="M144 70H138V76H144V70Z" fill="#FEF8EA"/>
    <path d="M108 70H102V76H108V70Z" fill="#FEF8EA"/>
    <path d="M102 76H96V82H102V76Z" fill="#FEF8EA"/>
    <path d="M114 82H108V88H114V82Z" fill="#E6EDF4"/>
    <path d="M120 82H114V88H120V82Z" fill="#E6EDF4"/>
    <path d="M126 82H120V88H126V82Z" fill="#E6EDF4"/>
    <path d="M132 82H126V88H132V82Z" fill="#E6EDF4"/>
    <path d="M138 82H132V88H138V82Z" fill="#E6EDF4"/>
    <path d="M144 82H138V88H144V82Z" fill="#E6EDF4"/>
    <path d="M150 82H144V88H150V82Z" fill="#E6EDF4"/>
    <path d="M156 82H150V88H156V82Z" fill="#E6EDF4"/>
    <path d="M162 82H156V88H162V82Z" fill="#E6EDF4"/>
    <path d="M162 76H156V82H162V76Z" fill="#E6EDF4"/>
    <path d="M168 76H162V82H168V76Z" fill="#E6EDF4"/>
    <path d="M168 70H162V76H168V70Z" fill="#E6EDF4"/>
    <path d="M162 70H156V76H162V70Z" fill="#E6EDF4"/>
    <path d="M156 70H150V76H156V70Z" fill="#E6EDF4"/>
    <path d="M150 70H144V76H150V70Z" fill="#E6EDF4"/>
    <path d="M174 76H168V82H174V76Z" fill="#E6EDF4"/>
    <path d="M180 76H174V82H180V76Z" fill="#E6EDF4"/>
    <path d="M186 76H180V82H186V76Z" fill="#E6EDF4"/>
    <path d="M192 76H186V82H192V76Z" fill="#E6EDF4"/>
    <path d="M156 76H150V82H156V76Z" fill="#E6EDF4"/>
    <path d="M150 76H144V82H150V76Z" fill="#E6EDF4"/>
    <path d="M144 76H138V82H144V76Z" fill="#E6EDF4"/>
    <path d="M138 76H132V82H138V76Z" fill="#E6EDF4"/>
    <path d="M132 76H126V82H132V76Z" fill="#E6EDF4"/>
    <path d="M126 76H120V82H126V76Z" fill="#E6EDF4"/>
    <path d="M120 76H114V82H120V76Z" fill="#E6EDF4"/>
    <path d="M114 76H108V82H114V76Z" fill="#E6EDF4"/>
    <path d="M108 76H102V82H108V76Z" fill="#E6EDF4"/>
    <path d="M150 58H144V64H150V58Z" fill="#FEF8EA"/>
    <path d="M144 58H138V64H144V58Z" fill="#FEF8EA"/>
    <path d="M156 58H150V64H156V58Z" fill="#FEF8EA"/>
    <path d="M162 58H156V64H162V58Z" fill="#FEF8EA"/>
    <path d="M168 58H162V64H168V58Z" fill="#FEF8EA"/>
    <path d="M126 58H120V64H126V58Z" fill="#E6EDF4"/>
    <path d="M132 58H126V64H132V58Z" fill="#E6EDF4"/>
    <path d="M138 58H132V64H138V58Z" fill="#E6EDF4"/>
    <path d="M12 70H6V76H12V70Z" fill="#FEF8EA"/>
    <path d="M18 70H12V76H18V70Z" fill="#FEF8EA"/>
    <path d="M24 70H18V76H24V70Z" fill="#FEF8EA"/>
    <path d="M30 70H24V76H30V70Z" fill="#FEF8EA"/>
    <path d="M36 70H30V76H36V70Z" fill="#FEF8EA"/>
    <path d="M42 70H36V76H42V70Z" fill="#FEF8EA"/>
    <path d="M18 76H12V82H18V76Z" fill="#FEF8EA"/>
    <path d="M24 76H18V82H24V76Z" fill="#FEF8EA"/>
    <path d="M30 76H24V82H30V76Z" fill="#FEF8EA"/>
    <path d="M36 76H30V82H36V76Z" fill="#FEF8EA"/>
    <path d="M42 76H36V82H42V76Z" fill="#FEF8EA"/>
    <path d="M228 43H222V49H228V43Z" fill="#FEF8EA"/>
    <path d="M234 43H228V49H234V43Z" fill="#FEF8EA"/>
    <path d="M240 37H234V43H240V37Z" fill="#FEF8EA"/>
    <path d="M240 43H234V49H240V43Z" fill="#E6EDF4"/>
    <path d="M246 43H240V49H246V43Z" fill="#E6EDF4"/>
    <path d="M252 43H246V49H252V43Z" fill="#E6EDF4"/>
    <path d="M240 49H234V55H240V49Z" fill="#E6EDF4"/>
    <path d="M246 49H240V55H246V49Z" fill="#E6EDF4"/>
    <path d="M252 49H246V55H252V49Z" fill="#E6EDF4"/>
    <path d="M258 43H252V49H258V43Z" fill="#E6EDF4"/>
    <path d="M264 43H258V49H264V43Z" fill="#E6EDF4"/>
    <path d="M270 43H264V49H270V43Z" fill="#E6EDF4"/>
    <path d="M276 43H270V49H276V43Z" fill="#E6EDF4"/>
    <path d="M246 37H240V43H246V37Z" fill="#FEF8EA"/>
    <path d="M252 37H246V43H252V37Z" fill="#FEF8EA"/>
    <path d="M258 37H252V43H258V37Z" fill="#FEF8EA"/>
    <path d="M264 37H258V43H264V37Z" fill="#FEF8EA"/>
    <path d="M270 37H264V43H270V37Z" fill="#FEF8EA"/>
    <path d="M276 37H270V43H276V37Z" fill="#FEF8EA"/>
    <path d="M282 37H276V43H282V37Z" fill="#FEF8EA"/>
    <path d="M265 56H259V62H265V56Z" fill="#FEF8EA"/>
    <path d="M271 62H265V68H271V62Z" fill="#FEF8EA"/>
    <path d="M271 74H265V80H271V74Z" fill="#FEF8EA"/>
    <path d="M265 74H259V80H265V74Z" fill="#FEF8EA"/>
    <path d="M271 68H265V74H271V68Z" fill="#FEF8EA"/>
    <path d="M259 74H253V80H259V74Z" fill="#FEF8EA"/>
    <path d="M265 68H259V74H265V68Z" fill="#FEF8EA"/>
    <path d="M253 68H247V74H253V68Z" fill="#E6EDF4"/>
    <path d="M259 68H253V74H259V68Z" fill="#FEF8EA"/>
    <path d="M253 74H247V80H253V74Z" fill="#E6EDF4"/>
    <path d="M247 68H241V74H247V68Z" fill="#FEF8EA"/>
    <path d="M247 74H241V80H247V74Z" fill="#E6EDF4"/>
    <path d="M241 74H235V80H241V74Z" fill="#E6EDF4"/>
    <path d="M235 74H229V80H235V74Z" fill="#E6EDF4"/>
    <path d="M229 74H223V80H229V74Z" fill="#FEF8EA"/>
    <path d="M686 76H680V82H686V76Z" fill="#FEF8EA"/>
    <path d="M680 82H674V88H680V82Z" fill="#FEF8EA"/>
    <path d="M680 76H674V82H680V76Z" fill="#FEF8EA"/>
    <path d="M680 70H674V76H680V70Z" fill="#FEF8EA"/>
    <path d="M674 82H668V88H674V82Z" fill="#FEF8EA"/>
    <path d="M674 76H668V82H674V76Z" fill="#FEF8EA"/>
    <path d="M674 70H668V76H674V70Z" fill="#FEF8EA"/>
    <path d="M668 82H662V88H668V82Z" fill="#FEF8EA"/>
    <path d="M668 76H662V82H668V76Z" fill="#FEF8EA"/>
    <path d="M668 70H662V76H668V70Z" fill="#FEF8EA"/>
    <path d="M668 63H662V70H668V63Z" fill="#FEF8EA"/>
    <path d="M662 82H656V88H662V82Z" fill="#FEF8EA"/>
    <path d="M662 76H656V82H662V76Z" fill="#FEF8EA"/>
    <path d="M662 64H656V70H662V64Z" fill="#FEF8EA"/>
    <path d="M656 82H650V88H656V82Z" fill="#FEF8EA"/>
    <path d="M656 76H650V82H656V76Z" fill="#FEF8EA"/>
    <path d="M656 64H650V70H656V64Z" fill="#FEF8EA"/>
    <path d="M650 82H644V88H650V82Z" fill="#FEF8EA"/>
    <path d="M644 82H638V88H644V82Z" fill="#FEF8EA"/>
    <path d="M638 82H632V88H638V82Z" fill="#FEF8EA"/>
    <path d="M632 82H626V88H632V82Z" fill="#FEF8EA"/>
    <path d="M626 82H620V88H626V82Z" fill="#FEF8EA"/>
    <path d="M620 82H614V88H620V82Z" fill="#FEF8EA"/>
    <path d="M614 82H608V88H614V82Z" fill="#FEF8EA"/>
    <path d="M595 82H589V88H595V82Z" fill="#FEF8EA"/>
    <path d="M589 88H583V94H589V88Z" fill="#FEF8EA"/>
    <path d="M589 82H583V88H589V82Z" fill="#FEF8EA"/>
    <path d="M589 70H583V76H589V70Z" fill="#FEF8EA"/>
    <path d="M583 88H577V94H583V88Z" fill="#FEF8EA"/>
    <path d="M583 82H577V88H583V82Z" fill="#FEF8EA"/>
    <path d="M583 76H577V82H583V76Z" fill="#FEF8EA"/>
    <path d="M583 70H577V76H583V70Z" fill="#FEF8EA"/>
    <path d="M577 88H571V94H577V88Z" fill="#FEF8EA"/>
    <path d="M577 82H571V88H577V82Z" fill="#FEF8EA"/>
    <path d="M577 76H571V82H577V76Z" fill="#FEF8EA"/>
    <path d="M577 70H571V76H577V70Z" fill="#FEF8EA"/>
    <path d="M571 88H565V94H571V88Z" fill="#FEF8EA"/>
    <path d="M571 82H565V88H571V82Z" fill="#FEF8EA"/>
    <path d="M571 76H565V82H571V76Z" fill="#FEF8EA"/>
    <path d="M571 70H565V76H571V70Z" fill="#FEF8EA"/>
    <path d="M565 88H559V94H565V88Z" fill="#FEF8EA"/>
    <path d="M565 82H559V88H565V82Z" fill="#FEF8EA"/>
    <path d="M565 76H559V82H565V76Z" fill="#FEF8EA"/>
    <path d="M565 70H559V76H565V70Z" fill="#FEF8EA"/>
    <path d="M559 88H553V94H559V88Z" fill="#FEF8EA"/>
    <path d="M559 82H553V88H559V82Z" fill="#FEF8EA"/>
    <path d="M559 76H553V82H559V76Z" fill="#FEF8EA"/>
    <path d="M559 70H553V76H559V70Z" fill="#FEF8EA"/>
    <path d="M553 88H547V94H553V88Z" fill="#FEF8EA"/>
    <path d="M553 82H547V88H553V82Z" fill="#FEF8EA"/>
    <path d="M553 76H547V82H553V76Z" fill="#FEF8EA"/>
    <path d="M553 70H547V76H553V70Z" fill="#FEF8EA"/>
    <path d="M547 88H541V94H547V88Z" fill="#FEF8EA"/>
    <path d="M547 82H541V88H547V82Z" fill="#FEF8EA"/>
    <path d="M547 70H541V76H547V70Z" fill="#FEF8EA"/>
    <path d="M541 82H535V88H541V82Z" fill="#FEF8EA"/>
    <path d="M535 88H529V94H535V88Z" fill="#FEF8EA"/>
    <path d="M529 88H523V94H529V88Z" fill="#FEF8EA"/>
    <path d="M523 88H517V94H523V88Z" fill="#FEF8EA"/>
    <path d="M517 88H511V94H517V88Z" fill="#FEF8EA"/>
    <path d="M511 88H505V94H511V88Z" fill="#FEF8EA"/>
    <path d="M505 88H499V94H505V88Z" fill="#FEF8EA"/>
    </svg>`;
  }

  sb() {
    return `<svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0H5V5H10V0Z" fill="#E6EDF4"/>
    <path d="M15 0H10V5H15V0Z" fill="#E6EDF4"/>
    <path d="M10 15H5V20H10V15Z" fill="#E6EDF4"/>
    <path d="M15 15H10V20H15V15Z" fill="#E6EDF4"/>
    <path d="M30 4.99998H25V9.99998H30V4.99998Z" fill="#E6EDF4"/>
    <path d="M30 9.99998H25V15H30V9.99998Z" fill="#E6EDF4"/>
    <path d="M20 0H15V5H20V0Z" fill="#E6EDF4"/>
    <path d="M25 0H20V5H25V0Z" fill="#E6EDF4"/>
    <path d="M5 4.99998H0V9.99998H5V4.99998Z" fill="#E6EDF4"/>
    <path d="M5 9.99998H0V15H5V9.99998Z" fill="#E6EDF4"/>
    <path d="M20 15H15V20H20V15Z" fill="#E6EDF4"/>
    <path d="M25 15H20V20H25V15Z" fill="#E6EDF4"/>
    <path d="M10 4.99998H5V9.99998H10V4.99998Z" fill="#FEF8EA"/>
    <path d="M10 9.99997H5V15H10V9.99997Z" fill="#FEF8EA"/>
    <path d="M15 4.99998H10V9.99998H15V4.99998Z" fill="#FEF8EA"/>
    <path d="M15 9.99997H10V15H15V9.99997Z" fill="#FEF8EA"/>
    <path d="M20 4.99998H15V9.99998H20V4.99998Z" fill="#FEF8EA"/>
    <path d="M20 9.99997H15V15H20V9.99997Z" fill="#FEF8EA"/>
    <path d="M25 4.99998H20V9.99998H25V4.99998Z" fill="#FEF8EA"/>
    <path d="M25 9.99997H20V15H25V9.99997Z" fill="#FEF8EA"/>
    </svg>`;
  }
}
